var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2000,
    zoomAndPan: "magnify",
    viewBox: "0 0 1500 1499.999933",
    height: 2000,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "6e3189cf7b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1068 852 L 1244 852 L 1244 1030 L 1068 1030 Z M 1068 852 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "adeb99e5a4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1068.449219 966.460938 C 1089.253906 986.398438 1108.324219 1008.066406 1126.527344 1029.738281 L 1127.390625 1028.871094 C 1129.125 1027.136719 1129.992188 1026.269531 1131.726562 1024.535156 C 1134.328125 1021.933594 1136.925781 1018.46875 1140.394531 1015.867188 C 1184.601562 969.0625 1220.136719 913.585938 1243.539062 852.046875 C 1192.402344 874.582031 1129.125 913.585938 1068.449219 966.460938 Z M 1068.449219 966.460938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 175.686031,
    gradientTransform: "matrix(8.667815, 0, 0, 8.667815, -255.991025, -277.370088)",
    y1: 135.166445,
    x2: 151.530126,
    gradientUnits: "userSpaceOnUse",
    y2: 148.499292,
    id: "a2b87fc3b2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.502686%, 66.949463%, 23.068237%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.479797%, 66.76178%, 23.066711%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.435547%, 66.389465%, 23.06366%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.389771%, 66.015625%, 23.060608%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.34552%, 65.643311%, 23.057556%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.299744%, 65.26947%, 23.05603%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.255493%, 64.897156%, 23.052979%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.211243%, 64.524841%, 23.049927%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.165466%, 64.151001%, 23.046875%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.121216%, 63.778687%, 23.043823%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.075439%, 63.404846%, 23.040771%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.031189%, 63.032532%, 23.039246%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.985413%, 62.658691%, 23.036194%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.941162%, 62.286377%, 23.033142%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.896912%, 61.914062%, 23.03009%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.851135%, 61.540222%, 23.027039%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.806885%, 61.167908%, 23.023987%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.761108%, 60.794067%, 23.022461%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.716858%, 60.421753%, 23.019409%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.671082%, 60.047913%, 23.016357%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.626831%, 59.675598%, 23.013306%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.582581%, 59.301758%, 23.010254%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.536804%, 58.929443%, 23.007202%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.492554%, 58.557129%, 23.005676%)",
    offset: 0.359035
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.469666%, 58.370972%, 23.00415%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.446777%, 58.183289%, 23.002625%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.402527%, 57.810974%, 22.999573%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.35675%, 57.437134%, 22.996521%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.3125%, 57.064819%, 22.993469%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.26825%, 56.690979%, 22.991943%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.222473%, 56.318665%, 22.988892%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.178223%, 55.944824%, 22.98584%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.132446%, 55.57251%, 22.982788%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.088196%, 55.200195%, 22.979736%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.042419%, 54.826355%, 22.976685%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.998169%, 54.454041%, 22.975159%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.953918%, 54.0802%, 22.972107%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.908142%, 53.707886%, 22.969055%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.863892%, 53.334045%, 22.966003%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.818115%, 52.961731%, 22.962952%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.773865%, 52.587891%, 22.9599%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.728088%, 52.215576%, 22.958374%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.683838%, 51.843262%, 22.955322%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.639587%, 51.469421%, 22.952271%)",
    offset: 0.640965
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.616699%, 51.283264%, 22.950745%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.593811%, 51.097107%, 22.949219%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.549561%, 50.723267%, 22.946167%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.503784%, 50.350952%, 22.943115%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.459534%, 49.977112%, 22.941589%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.413757%, 49.604797%, 22.938538%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.369507%, 49.230957%, 22.935486%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.325256%, 48.858643%, 22.932434%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.27948%, 48.486328%, 22.929382%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.235229%, 48.112488%, 22.926331%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.189453%, 47.740173%, 22.924805%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.145203%, 47.366333%, 22.921753%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.099426%, 46.994019%, 22.918701%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.055176%, 46.620178%, 22.915649%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.010925%, 46.247864%, 22.912598%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.965149%, 45.874023%, 22.911072%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.920898%, 45.501709%, 22.90802%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.875122%, 45.129395%, 22.904968%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.830872%, 44.755554%, 22.901917%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.785095%, 44.38324%, 22.898865%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.740845%, 44.009399%, 22.895813%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.696594%, 43.637085%, 22.894287%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.650818%, 43.263245%, 22.891235%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7bddf627ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 989 771 L 1267 771 L 1267 950 L 989 950 Z M 989 771 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a46c8ed738"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 989.574219 896.253906 C 1010.375 913.585938 1031.179688 930.921875 1050.25 949.125 C 1055.449219 944.792969 1061.515625 939.589844 1066.71875 935.257812 C 1136.058594 878.050781 1201.933594 839.910156 1253.941406 819.976562 C 1259.144531 804.375 1262.609375 787.902344 1266.078125 771.433594 C 1186.332031 787.039062 1089.253906 830.375 989.574219 896.253906 Z M 989.574219 896.253906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 176.25233,
    gradientTransform: "matrix(8.667815, 0, 0, 8.667815, -255.991025, -277.370088)",
    y1: 122.181876,
    x2: 143.128493,
    gradientUnits: "userSpaceOnUse",
    y2: 140.464573,
    id: "7f21786d99"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.207642%, 72.805786%, 23.112488%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.192383%, 72.677612%, 23.110962%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.161865%, 72.422791%, 23.10791%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.131348%, 72.166443%, 23.106384%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.10083%, 71.911621%, 23.104858%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.070312%, 71.655273%, 23.103333%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.038269%, 71.398926%, 23.100281%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.007751%, 71.144104%, 23.098755%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.977234%, 70.887756%, 23.097229%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.946716%, 70.632935%, 23.095703%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.916199%, 70.376587%, 23.092651%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.884155%, 70.120239%, 23.091125%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.853638%, 69.865417%, 23.0896%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.82312%, 69.60907%, 23.088074%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.792603%, 69.354248%, 23.085022%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.762085%, 69.0979%, 23.083496%)",
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.731567%, 68.843079%, 23.08197%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.699524%, 68.586731%, 23.080444%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.669006%, 68.330383%, 23.077393%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.638489%, 68.075562%, 23.075867%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.607971%, 67.819214%, 23.074341%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.577454%, 67.564392%, 23.072815%)",
    offset: 0.164063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.54541%, 67.308044%, 23.069763%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.514893%, 67.051697%, 23.068237%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.484375%, 66.796875%, 23.066711%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.453857%, 66.540527%, 23.065186%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.42334%, 66.285706%, 23.062134%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.392822%, 66.029358%, 23.060608%)",
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.360779%, 65.77301%, 23.059082%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.330261%, 65.518188%, 23.05603%)",
    offset: 0.226563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.299744%, 65.261841%, 23.054504%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.269226%, 65.007019%, 23.052979%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.238708%, 64.750671%, 23.051453%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.208191%, 64.494324%, 23.048401%)",
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.176147%, 64.239502%, 23.046875%)",
    offset: 0.26183
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.160889%, 64.111328%, 23.046875%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.14563%, 63.983154%, 23.045349%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.115112%, 63.728333%, 23.043823%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.084595%, 63.471985%, 23.040771%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.054077%, 63.215637%, 23.039246%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.022034%, 62.960815%, 23.03772%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.991516%, 62.704468%, 23.036194%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.960999%, 62.449646%, 23.033142%)",
    offset: 0.320313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.930481%, 62.193298%, 23.031616%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.899963%, 61.936951%, 23.03009%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.869446%, 61.682129%, 23.028564%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.837402%, 61.425781%, 23.025513%)",
    offset: 0.351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.806885%, 61.170959%, 23.023987%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.776367%, 60.914612%, 23.022461%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.74585%, 60.658264%, 23.020935%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.715332%, 60.403442%, 23.017883%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.683289%, 60.147095%, 23.016357%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.652771%, 59.892273%, 23.014832%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.622253%, 59.635925%, 23.013306%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.591736%, 59.379578%, 23.010254%)",
    offset: 0.414063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.561218%, 59.124756%, 23.008728%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.530701%, 58.868408%, 23.007202%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.498657%, 58.613586%, 23.005676%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.46814%, 58.357239%, 23.002625%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.437622%, 58.100891%, 23.001099%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.407104%, 57.846069%, 22.999573%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.376587%, 57.589722%, 22.998047%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.346069%, 57.3349%, 22.994995%)",
    offset: 0.476563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.314026%, 57.078552%, 22.993469%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.283508%, 56.822205%, 22.991943%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.252991%, 56.567383%, 22.990417%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.222473%, 56.311035%, 22.987366%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.191956%, 56.056213%, 22.98584%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.159912%, 55.799866%, 22.984314%)",
    offset: 0.523437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.129395%, 55.545044%, 22.982788%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.098877%, 55.288696%, 22.979736%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.068359%, 55.032349%, 22.97821%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.037842%, 54.777527%, 22.976685%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.007324%, 54.521179%, 22.975159%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.975281%, 54.266357%, 22.972107%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.944763%, 54.01001%, 22.970581%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.914246%, 53.753662%, 22.969055%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.883728%, 53.49884%, 22.967529%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.85321%, 53.242493%, 22.964478%)",
    offset: 0.601563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.821167%, 52.987671%, 22.962952%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.790649%, 52.731323%, 22.961426%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.760132%, 52.474976%, 22.9599%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.729614%, 52.220154%, 22.956848%)",
    offset: 0.632813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.699097%, 51.963806%, 22.955322%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.668579%, 51.708984%, 22.953796%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.636536%, 51.452637%, 22.952271%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.606018%, 51.196289%, 22.949219%)",
    offset: 0.664063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.5755%, 50.941467%, 22.947693%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.544983%, 50.68512%, 22.946167%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.514465%, 50.430298%, 22.944641%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.483948%, 50.17395%, 22.941589%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.451904%, 49.917603%, 22.940063%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.421387%, 49.662781%, 22.938538%)",
    offset: 0.710937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.390869%, 49.406433%, 22.937012%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.360352%, 49.151611%, 22.93396%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.329834%, 48.895264%, 22.932434%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.297791%, 48.638916%, 22.930908%)",
    offset: 0.73817
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.282532%, 48.512268%, 22.930908%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.267273%, 48.384094%, 22.929382%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.236755%, 48.127747%, 22.926331%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.206238%, 47.872925%, 22.924805%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.17572%, 47.616577%, 22.923279%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.145203%, 47.360229%, 22.921753%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.113159%, 47.105408%, 22.918701%)",
    offset: 0.789063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.082642%, 46.84906%, 22.917175%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.052124%, 46.594238%, 22.915649%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.021606%, 46.337891%, 22.914124%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.991089%, 46.081543%, 22.911072%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.959045%, 45.826721%, 22.909546%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.928528%, 45.570374%, 22.90802%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.89801%, 45.315552%, 22.904968%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.867493%, 45.059204%, 22.903442%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.836975%, 44.802856%, 22.901917%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.806458%, 44.548035%, 22.900391%)",
    offset: 0.867187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.774414%, 44.291687%, 22.897339%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.743896%, 44.036865%, 22.895813%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.713379%, 43.780518%, 22.894287%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.682861%, 43.52417%, 22.892761%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.652344%, 43.269348%, 22.889709%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.621826%, 43.013%, 22.888184%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.589783%, 42.758179%, 22.886658%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.559265%, 42.501831%, 22.885132%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.528748%, 42.245483%, 22.88208%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.49823%, 41.990662%, 22.880554%)",
    offset: 0.945313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.467712%, 41.734314%, 22.879028%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.435669%, 41.479492%, 22.877502%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.405151%, 41.223145%, 22.874451%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.374634%, 40.968323%, 22.872925%)",
    offset: 0.976563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.344116%, 40.711975%, 22.871399%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.313599%, 40.455627%, 22.869873%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.283081%, 40.200806%, 22.866821%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e79e4051e7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 901 702 L 1275 702 L 1275 880 L 901 880 Z M 901 702 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2c2554f89c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 901.164062 830.375 C 924.566406 845.980469 947.96875 862.449219 969.636719 879.78125 C 1077.117188 806.972656 1183.734375 760.167969 1270.410156 746.296875 C 1273.011719 731.5625 1273.878906 717.695312 1274.746094 702.960938 C 1174.199219 711.628906 1037.246094 758.433594 901.164062 830.375 Z M 901.164062 830.375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 175.674322,
    gradientTransform: "matrix(8.667815, 0, 0, 8.667815, -255.991025, -277.370088)",
    y1: 111.422912,
    x2: 134.008112,
    gradientUnits: "userSpaceOnUse",
    y2: 134.420577,
    id: "6124579b3c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.698975%, 76.872253%, 23.139954%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.679138%, 76.708984%, 23.139954%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.639465%, 76.383972%, 23.138428%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.599792%, 76.062012%, 23.135376%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.561646%, 75.740051%, 23.13385%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.521973%, 75.419617%, 23.130798%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.483826%, 75.097656%, 23.129272%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.445679%, 74.775696%, 23.126221%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.406006%, 74.453735%, 23.123169%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.367859%, 74.131775%, 23.121643%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.328186%, 73.809814%, 23.118591%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.290039%, 73.48938%, 23.117065%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.251892%, 73.167419%, 23.114014%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.212219%, 72.845459%, 23.112488%)",
    offset: 0.101563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.174072%, 72.523499%, 23.109436%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.134399%, 72.201538%, 23.106384%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.096252%, 71.881104%, 23.104858%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.058105%, 71.559143%, 23.101807%)",
    offset: 0.132813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.018433%, 71.237183%, 23.100281%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.980286%, 70.915222%, 23.097229%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.942139%, 70.593262%, 23.095703%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.902466%, 70.271301%, 23.092651%)",
    offset: 0.164063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.864319%, 69.950867%, 23.0896%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.824646%, 69.628906%, 23.088074%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.786499%, 69.306946%, 23.085022%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.748352%, 68.984985%, 23.083496%)",
    offset: 0.195313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.708679%, 68.663025%, 23.080444%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.670532%, 68.34259%, 23.077393%)",
    offset: 0.207134
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.650696%, 68.182373%, 23.077393%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.630859%, 68.02063%, 23.075867%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.592712%, 67.698669%, 23.072815%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.554565%, 67.376709%, 23.071289%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.514893%, 67.054749%, 23.068237%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.476746%, 66.732788%, 23.066711%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.438599%, 66.412354%, 23.06366%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.398926%, 66.090393%, 23.060608%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.360779%, 65.768433%, 23.059082%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.321106%, 65.446472%, 23.05603%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.282959%, 65.124512%, 23.054504%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.244812%, 64.804077%, 23.051453%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.205139%, 64.482117%, 23.049927%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.166992%, 64.160156%, 23.046875%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.128845%, 63.838196%, 23.043823%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.089172%, 63.516235%, 23.042297%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.051025%, 63.194275%, 23.039246%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.011353%, 62.87384%, 23.03772%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.973206%, 62.55188%, 23.034668%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.935059%, 62.229919%, 23.033142%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.895386%, 61.907959%, 23.03009%)",
    offset: 0.367187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.857239%, 61.585999%, 23.027039%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.817566%, 61.265564%, 23.025513%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.779419%, 60.943604%, 23.022461%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.741272%, 60.621643%, 23.020935%)",
    offset: 0.398437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.701599%, 60.299683%, 23.017883%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.663452%, 59.977722%, 23.016357%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.625305%, 59.655762%, 23.013306%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.585632%, 59.335327%, 23.010254%)",
    offset: 0.429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.547485%, 59.013367%, 23.008728%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.507812%, 58.691406%, 23.005676%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.469666%, 58.369446%, 23.00415%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.431519%, 58.047485%, 23.001099%)",
    offset: 0.460937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.391846%, 57.727051%, 22.998047%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.353699%, 57.40509%, 22.996521%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.314026%, 57.08313%, 22.993469%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.275879%, 56.761169%, 22.991943%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.237732%, 56.439209%, 22.988892%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.198059%, 56.117249%, 22.987366%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.159912%, 55.796814%, 22.984314%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.121765%, 55.474854%, 22.981262%)",
    offset: 0.523437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.082092%, 55.152893%, 22.979736%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.043945%, 54.830933%, 22.976685%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.004272%, 54.508972%, 22.975159%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.966125%, 54.188538%, 22.972107%)",
    offset: 0.554687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.927979%, 53.866577%, 22.970581%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.888306%, 53.544617%, 22.967529%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.850159%, 53.222656%, 22.964478%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.812012%, 52.900696%, 22.962952%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.772339%, 52.578735%, 22.9599%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.734192%, 52.258301%, 22.958374%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.694519%, 51.93634%, 22.955322%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.656372%, 51.61438%, 22.953796%)",
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.618225%, 51.292419%, 22.950745%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.578552%, 50.970459%, 22.947693%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.540405%, 50.650024%, 22.946167%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.500732%, 50.328064%, 22.943115%)",
    offset: 0.648437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.462585%, 50.006104%, 22.941589%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.424438%, 49.684143%, 22.938538%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.384766%, 49.362183%, 22.935486%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.346619%, 49.040222%, 22.93396%)",
    offset: 0.679687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.308472%, 48.719788%, 22.930908%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.268799%, 48.397827%, 22.929382%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.230652%, 48.075867%, 22.926331%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.190979%, 47.753906%, 22.924805%)",
    offset: 0.710937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.152832%, 47.431946%, 22.921753%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.114685%, 47.111511%, 22.918701%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.075012%, 46.789551%, 22.917175%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.036865%, 46.46759%, 22.914124%)",
    offset: 0.742187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.997192%, 46.14563%, 22.912598%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.959045%, 45.823669%, 22.909546%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.920898%, 45.501709%, 22.90802%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.881226%, 45.181274%, 22.904968%)",
    offset: 0.773437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.843079%, 44.859314%, 22.901917%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.804932%, 44.537354%, 22.900391%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.765259%, 44.215393%, 22.897339%)",
    offset: 0.792866
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.746948%, 44.055176%, 22.897339%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.727112%, 43.893433%, 22.895813%)",
    offset: 0.804687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.687439%, 43.572998%, 22.892761%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.649292%, 43.251038%, 22.891235%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.611145%, 42.929077%, 22.888184%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.571472%, 42.607117%, 22.885132%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.533325%, 42.285156%, 22.883606%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.495178%, 41.963196%, 22.880554%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.455505%, 41.642761%, 22.879028%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.417358%, 41.320801%, 22.875977%)",
    offset: 0.867187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.377686%, 40.99884%, 22.874451%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.339539%, 40.67688%, 22.871399%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.301392%, 40.354919%, 22.868347%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.261719%, 40.034485%, 22.866821%)",
    offset: 0.898437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.223572%, 39.712524%, 22.86377%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.183899%, 39.390564%, 22.862244%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.145752%, 39.068604%, 22.859192%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.107605%, 38.746643%, 22.85614%)",
    offset: 0.929687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.067932%, 38.424683%, 22.854614%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.029785%, 38.104248%, 22.851562%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.991638%, 37.782288%, 22.850037%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.951965%, 37.460327%, 22.846985%)",
    offset: 0.960937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.913818%, 37.138367%, 22.845459%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.874146%, 36.816406%, 22.842407%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.835999%, 36.495972%, 22.839355%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.797852%, 36.174011%, 22.83783%)",
    offset: 0.992187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.758179%, 35.852051%, 22.834778%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8aa83ff1ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 804 654 L 1276 654 L 1276 815 L 804 815 Z M 804 654 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3e938ebae2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 804.949219 772.300781 C 829.21875 785.304688 853.488281 800.039062 876.890625 814.773438 C 1022.511719 735.898438 1167.265625 686.492188 1275.613281 677.824219 C 1275.613281 670.023438 1275.613281 662.222656 1275.613281 654.421875 C 1113.523438 659.621094 950.570312 702.09375 804.949219 772.300781 Z M 804.949219 772.300781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 173.819531,
    gradientTransform: "matrix(8.667815, 0, 0, 8.667815, -255.991025, -277.370088)",
    y1: 102.281286,
    x2: 124.372446,
    gradientUnits: "userSpaceOnUse",
    y2: 129.573594,
    id: "ae0df2612f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.00415%, 79.315186%, 23.139954%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.979736%, 79.121399%, 23.139954%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.932434%, 78.735352%, 23.139954%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.883606%, 78.349304%, 23.139954%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.834778%, 77.963257%, 23.139954%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.787476%, 77.577209%, 23.139954%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.738647%, 77.191162%, 23.139954%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.691345%, 76.805115%, 23.139954%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.642517%, 76.420593%, 23.138428%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.596741%, 76.039124%, 23.135376%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.550964%, 75.656128%, 23.132324%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.505188%, 75.274658%, 23.130798%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.459412%, 74.893188%, 23.127747%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.413635%, 74.511719%, 23.124695%)",
    offset: 0.101563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.367859%, 74.130249%, 23.121643%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.322083%, 73.747253%, 23.118591%)",
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.276306%, 73.365784%, 23.11554%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.229004%, 72.984314%, 23.112488%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.183228%, 72.602844%, 23.110962%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.137451%, 72.221375%, 23.10791%)",
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.091675%, 71.838379%, 23.104858%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.045898%, 71.456909%, 23.101807%)",
    offset: 0.158284
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.02301%, 71.266174%, 23.100281%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.000122%, 71.075439%, 23.098755%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.954346%, 70.69397%, 23.095703%)",
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.908569%, 70.3125%, 23.092651%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.861267%, 69.93103%, 23.0896%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.815491%, 69.548035%, 23.088074%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.769714%, 69.166565%, 23.085022%)",
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.723938%, 68.785095%, 23.08197%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.678162%, 68.403625%, 23.078918%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.632385%, 68.022156%, 23.075867%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.586609%, 67.63916%, 23.072815%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.540833%, 67.25769%, 23.069763%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.49353%, 66.876221%, 23.066711%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.447754%, 66.494751%, 23.065186%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.401978%, 66.113281%, 23.062134%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.356201%, 65.730286%, 23.059082%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.310425%, 65.348816%, 23.05603%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.264648%, 64.967346%, 23.052979%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.218872%, 64.585876%, 23.049927%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.173096%, 64.204407%, 23.046875%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.125793%, 63.822937%, 23.043823%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.080017%, 63.439941%, 23.042297%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.034241%, 63.058472%, 23.039246%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.988464%, 62.677002%, 23.036194%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.942688%, 62.295532%, 23.033142%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.896912%, 61.914062%, 23.03009%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.851135%, 61.531067%, 23.027039%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.805359%, 61.149597%, 23.023987%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.758057%, 60.768127%, 23.022461%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.71228%, 60.386658%, 23.019409%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.666504%, 60.005188%, 23.016357%)",
    offset: 0.398437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.620728%, 59.623718%, 23.013306%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.574951%, 59.240723%, 23.010254%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.529175%, 58.859253%, 23.007202%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.483398%, 58.477783%, 23.00415%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.437622%, 58.096313%, 23.001099%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.39032%, 57.714844%, 22.999573%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.344543%, 57.331848%, 22.996521%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.298767%, 56.950378%, 22.993469%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.252991%, 56.568909%, 22.990417%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.207214%, 56.187439%, 22.987366%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.161438%, 55.805969%, 22.984314%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.115662%, 55.422974%, 22.981262%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.069885%, 55.041504%, 22.97821%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.024109%, 54.660034%, 22.976685%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.976807%, 54.278564%, 22.973633%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.93103%, 53.897095%, 22.970581%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.885254%, 53.515625%, 22.967529%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.839478%, 53.132629%, 22.964478%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.793701%, 52.75116%, 22.961426%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.747925%, 52.36969%, 22.958374%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.702148%, 51.98822%, 22.956848%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.656372%, 51.60675%, 22.953796%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.60907%, 51.223755%, 22.950745%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.563293%, 50.842285%, 22.947693%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.517517%, 50.460815%, 22.944641%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.471741%, 50.079346%, 22.941589%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.425964%, 49.697876%, 22.938538%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.380188%, 49.31488%, 22.935486%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.334412%, 48.933411%, 22.93396%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.288635%, 48.551941%, 22.930908%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.241333%, 48.170471%, 22.927856%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.195557%, 47.789001%, 22.924805%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.14978%, 47.407532%, 22.921753%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.104004%, 47.024536%, 22.918701%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.058228%, 46.643066%, 22.915649%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.012451%, 46.261597%, 22.912598%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.966675%, 45.880127%, 22.911072%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.920898%, 45.498657%, 22.90802%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.873596%, 45.115662%, 22.904968%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.82782%, 44.734192%, 22.901917%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.782043%, 44.352722%, 22.898865%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.736267%, 43.971252%, 22.895813%)",
    offset: 0.726563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.690491%, 43.589783%, 22.892761%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.644714%, 43.206787%, 22.889709%)",
    offset: 0.742187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.598938%, 42.825317%, 22.888184%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.553162%, 42.443848%, 22.885132%)",
    offset: 0.757813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.505859%, 42.062378%, 22.88208%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.460083%, 41.680908%, 22.879028%)",
    offset: 0.773437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.414307%, 41.299438%, 22.875977%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.36853%, 40.916443%, 22.872925%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.322754%, 40.534973%, 22.869873%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.276978%, 40.153503%, 22.868347%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.231201%, 39.772034%, 22.865295%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.185425%, 39.390564%, 22.862244%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.139648%, 39.007568%, 22.859192%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.092346%, 38.626099%, 22.85614%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.04657%, 38.244629%, 22.853088%)",
    offset: 0.841716
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.023682%, 38.053894%, 22.851562%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.000793%, 37.863159%, 22.850037%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.955017%, 37.481689%, 22.846985%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.909241%, 37.098694%, 22.845459%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.863464%, 36.717224%, 22.842407%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.817688%, 36.335754%, 22.839355%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.771912%, 35.954285%, 22.836304%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.724609%, 35.572815%, 22.833252%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.678833%, 35.191345%, 22.8302%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.633057%, 34.80835%, 22.827148%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.58728%, 34.42688%, 22.824097%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.541504%, 34.04541%, 22.822571%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.495728%, 33.66394%, 22.819519%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.449951%, 33.282471%, 22.816467%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.404175%, 32.899475%, 22.813416%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.356873%, 32.518005%, 22.810364%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.311096%, 32.136536%, 22.807312%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.26532%, 31.755066%, 22.80426%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.219543%, 31.373596%, 22.801208%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.173767%, 30.990601%, 22.799683%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(92.127991%, 30.609131%, 22.796631%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fe51a15df9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 310 851 L 649 851 L 649 1155 L 310 1155 Z M 310 851 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "13c290cf21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 310.882812 851.179688 C 368.089844 999.398438 493.773438 1112.949219 648.0625 1154.554688 C 555.316406 1001.132812 410.5625 896.253906 310.882812 851.179688 Z M 310.882812 851.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 64.493455,
    gradientTransform: "matrix(8.667815, 0, 0, 8.667815, -255.991025, -277.370088)",
    y1: 131.217803,
    x2: 103.568456,
    gradientUnits: "userSpaceOnUse",
    y2: 166.021325,
    id: "1480a00c60"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.669678%, 69.233704%, 24.081421%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.558289%, 69.160461%, 24.075317%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.338562%, 69.012451%, 24.064636%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.118835%, 68.865967%, 24.053955%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.897583%, 68.719482%, 24.043274%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.677856%, 68.571472%, 24.031067%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.456604%, 68.424988%, 24.020386%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.236877%, 68.278503%, 24.009705%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.015625%, 68.130493%, 23.999023%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.795898%, 67.984009%, 23.988342%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.574646%, 67.837524%, 23.976135%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.354919%, 67.689514%, 23.965454%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.133667%, 67.54303%, 23.954773%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.91394%, 67.396545%, 23.944092%)",
    offset: 0.101563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.694214%, 67.248535%, 23.933411%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.472961%, 67.102051%, 23.922729%)",
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.253235%, 66.955566%, 23.910522%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.031982%, 66.809082%, 23.899841%)",
    offset: 0.132813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.812256%, 66.661072%, 23.88916%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.591003%, 66.514587%, 23.878479%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.371277%, 66.368103%, 23.867798%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.150024%, 66.220093%, 23.855591%)",
    offset: 0.164063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.930298%, 66.073608%, 23.84491%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.710571%, 65.927124%, 23.834229%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.489319%, 65.779114%, 23.823547%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.269592%, 65.632629%, 23.812866%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.04834%, 65.486145%, 23.800659%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.828613%, 65.338135%, 23.789978%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.607361%, 65.19165%, 23.779297%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.387634%, 65.045166%, 23.768616%)",
    offset: 0.226563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.166382%, 64.897156%, 23.757935%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.946655%, 64.750671%, 23.747253%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.725403%, 64.604187%, 23.735046%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.505676%, 64.456177%, 23.724365%)",
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.28595%, 64.309692%, 23.713684%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.064697%, 64.163208%, 23.703003%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.844971%, 64.015198%, 23.692322%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.623718%, 63.868713%, 23.680115%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.403992%, 63.722229%, 23.669434%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.182739%, 63.574219%, 23.658752%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.963013%, 63.427734%, 23.648071%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.74176%, 63.28125%, 23.63739%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.522034%, 63.13324%, 23.626709%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.302307%, 62.986755%, 23.614502%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.081055%, 62.840271%, 23.603821%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.861328%, 62.692261%, 23.59314%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.640076%, 62.545776%, 23.582458%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.420349%, 62.399292%, 23.571777%)",
    offset: 0.367187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.199097%, 62.251282%, 23.55957%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.97937%, 62.104797%, 23.548889%)",
    offset: 0.382813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.758118%, 61.958313%, 23.538208%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.538391%, 61.810303%, 23.527527%)",
    offset: 0.398437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.317139%, 61.663818%, 23.516846%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.097412%, 61.517334%, 23.504639%)",
    offset: 0.414063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.877686%, 61.369324%, 23.493958%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.656433%, 61.222839%, 23.483276%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.436707%, 61.076355%, 23.472595%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.215454%, 60.928345%, 23.461914%)",
    offset: 0.444872
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.105591%, 60.855103%, 23.457336%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.995728%, 60.78186%, 23.451233%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.774475%, 60.635376%, 23.439026%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.554749%, 60.487366%, 23.428345%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.333496%, 60.340881%, 23.417664%)",
    offset: 0.476563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.11377%, 60.194397%, 23.406982%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.894043%, 60.047913%, 23.396301%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.672791%, 59.899902%, 23.384094%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.453064%, 59.753418%, 23.373413%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.231812%, 59.606934%, 23.362732%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.012085%, 59.458923%, 23.352051%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.790833%, 59.312439%, 23.34137%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.571106%, 59.165955%, 23.330688%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.349854%, 59.017944%, 23.318481%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.130127%, 58.87146%, 23.3078%)",
    offset: 0.554687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.908875%, 58.724976%, 23.297119%)",
    offset: 0.555128
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.799011%, 58.651733%, 23.292542%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.689148%, 58.576965%, 23.286438%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.469421%, 58.430481%, 23.275757%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.248169%, 58.283997%, 23.26355%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.028442%, 58.135986%, 23.252869%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.80719%, 57.989502%, 23.242188%)",
    offset: 0.601563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.587463%, 57.843018%, 23.231506%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.366211%, 57.695007%, 23.220825%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.146484%, 57.548523%, 23.210144%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.925232%, 57.402039%, 23.197937%)",
    offset: 0.632813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.705505%, 57.254028%, 23.187256%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.485779%, 57.107544%, 23.176575%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.264526%, 56.96106%, 23.165894%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.0448%, 56.813049%, 23.155212%)",
    offset: 0.664063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.823547%, 56.666565%, 23.143005%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.603821%, 56.520081%, 23.132324%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.382568%, 56.37207%, 23.121643%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.162842%, 56.225586%, 23.110962%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.941589%, 56.079102%, 23.100281%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.721863%, 55.931091%, 23.088074%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.50061%, 55.784607%, 23.077393%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.280884%, 55.638123%, 23.066711%)",
    offset: 0.726563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.061157%, 55.490112%, 23.05603%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.839905%, 55.343628%, 23.045349%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.620178%, 55.197144%, 23.034668%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.398926%, 55.049133%, 23.022461%)",
    offset: 0.757813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.179199%, 54.902649%, 23.01178%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.957947%, 54.756165%, 23.001099%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.73822%, 54.608154%, 22.990417%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.516968%, 54.46167%, 22.979736%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.297241%, 54.315186%, 22.967529%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.077515%, 54.167175%, 22.956848%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.856262%, 54.020691%, 22.946167%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.636536%, 53.874207%, 22.935486%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.415283%, 53.726196%, 22.924805%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.195557%, 53.579712%, 22.914124%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.974304%, 53.433228%, 22.901917%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.754578%, 53.286743%, 22.891235%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.533325%, 53.138733%, 22.880554%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.313599%, 52.992249%, 22.869873%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.092346%, 52.845764%, 22.859192%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.87262%, 52.697754%, 22.846985%)",
    offset: 0.882813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.652893%, 52.55127%, 22.836304%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.431641%, 52.404785%, 22.825623%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.211914%, 52.256775%, 22.814941%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.990662%, 52.110291%, 22.80426%)",
    offset: 0.914063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.770935%, 51.963806%, 22.792053%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.549683%, 51.815796%, 22.781372%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.329956%, 51.669312%, 22.770691%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.108704%, 51.522827%, 22.76001%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.888977%, 51.374817%, 22.749329%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.66925%, 51.228333%, 22.738647%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.447998%, 51.081848%, 22.72644%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.228271%, 50.933838%, 22.715759%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.007019%, 50.787354%, 22.705078%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.787292%, 50.640869%, 22.694397%)",
    offset: 0.992187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.56604%, 50.492859%, 22.683716%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "12b6fe9c6a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 287 771 L 850 771 L 850 1172 L 287 1172 Z M 287 771 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5a1d2137f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 287.480469 771.433594 C 290.949219 787.90625 295.28125 803.507812 299.617188 819.109375 C 351.621094 839.042969 418.363281 877.183594 488.574219 935.257812 C 549.25 985.53125 624.660156 1060.941406 681.867188 1161.488281 C 686.199219 1162.355469 690.535156 1163.21875 694 1164.085938 C 697.46875 1164.953125 700.9375 1164.953125 704.402344 1165.820312 C 707.871094 1166.6875 710.46875 1166.6875 713.9375 1166.6875 C 715.671875 1166.6875 718.269531 1167.554688 720.003906 1167.554688 C 721.738281 1167.554688 724.339844 1168.421875 726.074219 1168.421875 C 742.542969 1170.15625 759.875 1171.023438 777.210938 1171.023438 C 801.480469 1171.023438 825.753906 1169.289062 849.15625 1165.820312 C 796.28125 1085.210938 711.335938 1000.265625 606.457031 923.988281 C 492.90625 842.511719 378.492188 787.90625 287.480469 771.433594 Z M 287.480469 771.433594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 65.581951,
    gradientTransform: "matrix(8.667815, 0, 0, 8.667815, -255.991025, -277.370088)",
    y1: 117.764348,
    x2: 124.612411,
    gradientUnits: "userSpaceOnUse",
    y2: 170.34199,
    id: 6879027539
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.055054%, 72.158813%, 24.299622%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.888733%, 72.047424%, 24.290466%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.556091%, 71.824646%, 24.273682%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.22345%, 71.603394%, 24.256897%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.889282%, 71.380615%, 24.241638%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.556641%, 71.159363%, 24.224854%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.223999%, 70.936584%, 24.208069%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.891357%, 70.715332%, 24.191284%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.558716%, 70.492554%, 24.1745%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.224548%, 70.271301%, 24.157715%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.891907%, 70.048523%, 24.142456%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.559265%, 69.827271%, 24.125671%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.226624%, 69.604492%, 24.108887%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.892456%, 69.38324%, 24.092102%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.559814%, 69.160461%, 24.075317%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.227173%, 68.939209%, 24.058533%)",
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.894531%, 68.716431%, 24.041748%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.56189%, 68.495178%, 24.026489%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.227722%, 68.2724%, 24.009705%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.895081%, 68.051147%, 23.99292%)",
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.562439%, 67.828369%, 23.976135%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.229797%, 67.605591%, 23.959351%)",
    offset: 0.164063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.897156%, 67.384338%, 23.942566%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.562988%, 67.16156%, 23.925781%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.230347%, 66.940308%, 23.910522%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.897705%, 66.717529%, 23.893738%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.565063%, 66.496277%, 23.876953%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.230896%, 66.273499%, 23.860168%)",
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.898254%, 66.052246%, 23.843384%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.565613%, 65.829468%, 23.826599%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.232971%, 65.608215%, 23.809814%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.90033%, 65.385437%, 23.794556%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.566162%, 65.164185%, 23.777771%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.233521%, 64.941406%, 23.760986%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.900879%, 64.720154%, 23.744202%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.568237%, 64.497375%, 23.727417%)",
    offset: 0.273437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.23407%, 64.276123%, 23.710632%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.901428%, 64.053345%, 23.693848%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.568787%, 63.832092%, 23.678589%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.236145%, 63.609314%, 23.661804%)",
    offset: 0.304687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.903503%, 63.388062%, 23.64502%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.569336%, 63.165283%, 23.628235%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.236694%, 62.944031%, 23.61145%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.904053%, 62.721252%, 23.594666%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.571411%, 62.5%, 23.577881%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.23877%, 62.277222%, 23.562622%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.904602%, 62.055969%, 23.545837%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.57196%, 61.833191%, 23.529053%)",
    offset: 0.367187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.239319%, 61.611938%, 23.512268%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.906677%, 61.38916%, 23.495483%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.57251%, 61.166382%, 23.478699%)",
    offset: 0.387875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.406189%, 61.056519%, 23.471069%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.239868%, 60.945129%, 23.46344%)",
    offset: 0.398437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.907227%, 60.722351%, 23.446655%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.574585%, 60.501099%, 23.429871%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.241943%, 60.27832%, 23.413086%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.907776%, 60.057068%, 23.396301%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.575134%, 59.83429%, 23.379517%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.242493%, 59.613037%, 23.362732%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.909851%, 59.390259%, 23.347473%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.575684%, 59.169006%, 23.330688%)",
    offset: 0.460937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.243042%, 58.946228%, 23.313904%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.9104%, 58.724976%, 23.297119%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.577759%, 58.502197%, 23.280334%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.245117%, 58.280945%, 23.26355%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.91095%, 58.058167%, 23.246765%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.578308%, 57.836914%, 23.231506%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.245667%, 57.614136%, 23.214722%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.913025%, 57.392883%, 23.197937%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.580383%, 57.170105%, 23.181152%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.246216%, 56.948853%, 23.164368%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.913574%, 56.726074%, 23.147583%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.580933%, 56.504822%, 23.130798%)",
    offset: 0.554687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.248291%, 56.282043%, 23.11554%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.914124%, 56.060791%, 23.098755%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.581482%, 55.838013%, 23.08197%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.24884%, 55.61676%, 23.065186%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.916199%, 55.393982%, 23.048401%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.583557%, 55.172729%, 23.031616%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.24939%, 54.949951%, 23.014832%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.916748%, 54.727173%, 22.999573%)",
    offset: 0.612125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.750427%, 54.61731%, 22.991943%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.584106%, 54.50592%, 22.982788%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.251465%, 54.283142%, 22.966003%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.917297%, 54.06189%, 22.949219%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.584656%, 53.839111%, 22.932434%)",
    offset: 0.648437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.252014%, 53.617859%, 22.915649%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.919373%, 53.395081%, 22.898865%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.586731%, 53.173828%, 22.883606%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.252563%, 52.95105%, 22.866821%)",
    offset: 0.679687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.919922%, 52.729797%, 22.850037%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.58728%, 52.507019%, 22.833252%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.254639%, 52.285767%, 22.816467%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.921997%, 52.062988%, 22.799683%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.58783%, 51.841736%, 22.784424%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.255188%, 51.618958%, 22.767639%)",
    offset: 0.726563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.922546%, 51.397705%, 22.750854%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.589905%, 51.174927%, 22.73407%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.255737%, 50.953674%, 22.717285%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.923096%, 50.730896%, 22.7005%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.590454%, 50.509644%, 22.683716%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.257812%, 50.286865%, 22.668457%)",
    offset: 0.773437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.925171%, 50.065613%, 22.651672%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.591003%, 49.842834%, 22.634888%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.258362%, 49.621582%, 22.618103%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.92572%, 49.398804%, 22.601318%)",
    offset: 0.804687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.593079%, 49.177551%, 22.584534%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.258911%, 48.954773%, 22.567749%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.92627%, 48.733521%, 22.55249%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.593628%, 48.510742%, 22.535706%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.260986%, 48.287964%, 22.518921%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.928345%, 48.066711%, 22.502136%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.594177%, 47.843933%, 22.485352%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.261536%, 47.622681%, 22.468567%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.928894%, 47.399902%, 22.451782%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.596252%, 47.17865%, 22.436523%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.263611%, 46.955872%, 22.419739%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.929443%, 46.734619%, 22.402954%)",
    offset: 0.898437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.596802%, 46.511841%, 22.386169%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.26416%, 46.290588%, 22.369385%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.931519%, 46.06781%, 22.3526%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.597351%, 45.846558%, 22.335815%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.264709%, 45.623779%, 22.320557%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.932068%, 45.402527%, 22.303772%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.599426%, 45.179749%, 22.286987%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.266785%, 44.958496%, 22.270203%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.932617%, 44.735718%, 22.253418%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.599976%, 44.514465%, 22.236633%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.267334%, 44.291687%, 22.221375%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.934692%, 44.070435%, 22.20459%)",
    offset: 0.992187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.600525%, 43.847656%, 22.187805%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b49103cfb0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 278 702 L 1014 702 L 1014 1163 L 278 1163 Z M 278 702 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "913989b0b2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 278.8125 702.960938 C 279.679688 717.695312 281.414062 732.429688 283.148438 746.296875 C 379.359375 761.902344 500.710938 818.242188 621.191406 904.917969 C 732.140625 984.664062 822.285156 1076.542969 876.027344 1162.355469 C 924.566406 1152.820312 971.371094 1135.484375 1013.84375 1112.949219 C 953.167969 1029.734375 844.820312 940.457031 707.003906 860.714844 C 553.582031 770.570312 393.226562 712.496094 278.8125 702.960938 Z M 278.8125 702.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 68.108605,
    gradientTransform: "matrix(8.667815, 0, 0, 8.667815, -255.991025, -277.370088)",
    y1: 105.904868,
    x2: 141.718544,
    gradientUnits: "userSpaceOnUse",
    y2: 171.468252,
    id: "7178b202e8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.291443%, 74.316406%, 24.461365%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.083923%, 74.177551%, 24.450684%)",
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.876404%, 74.038696%, 24.440002%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.668884%, 73.899841%, 24.429321%)",
    offset: 0.0117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.461365%, 73.762512%, 24.41864%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.252319%, 73.623657%, 24.407959%)",
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.0448%, 73.484802%, 24.398804%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.83728%, 73.345947%, 24.388123%)",
    offset: 0.0273437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.629761%, 73.208618%, 24.377441%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.422241%, 73.069763%, 24.36676%)",
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.214722%, 72.932434%, 24.357605%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.007202%, 72.793579%, 24.346924%)",
    offset: 0.0429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.799683%, 72.654724%, 24.336243%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.592163%, 72.515869%, 24.325562%)",
    offset: 0.0507813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.384644%, 72.37854%, 24.316406%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.177124%, 72.239685%, 24.305725%)",
    offset: 0.0585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.969604%, 72.10083%, 24.295044%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.762085%, 71.961975%, 24.284363%)",
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.554565%, 71.824646%, 24.275208%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.347046%, 71.685791%, 24.264526%)",
    offset: 0.0742187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.139526%, 71.546936%, 24.253845%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.932007%, 71.408081%, 24.243164%)",
    offset: 0.0820313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.724487%, 71.270752%, 24.234009%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.515442%, 71.131897%, 24.223328%)",
    offset: 0.0898437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.307922%, 70.993042%, 24.212646%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.100403%, 70.854187%, 24.201965%)",
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.892883%, 70.716858%, 24.19281%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.685364%, 70.578003%, 24.182129%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.477844%, 70.439148%, 24.171448%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.270325%, 70.300293%, 24.160767%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.062805%, 70.162964%, 24.151611%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.855286%, 70.024109%, 24.14093%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.647766%, 69.88678%, 24.130249%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.440247%, 69.747925%, 24.119568%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.232727%, 69.60907%, 24.108887%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.025208%, 69.470215%, 24.098206%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.817688%, 69.332886%, 24.08905%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.610168%, 69.194031%, 24.078369%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.402649%, 69.055176%, 24.067688%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.193604%, 68.916321%, 24.057007%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.986084%, 68.778992%, 24.047852%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.778564%, 68.640137%, 24.03717%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.571045%, 68.501282%, 24.026489%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.363525%, 68.362427%, 24.015808%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.156006%, 68.225098%, 24.006653%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.948486%, 68.086243%, 23.995972%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.740967%, 67.947388%, 23.985291%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.533447%, 67.808533%, 23.974609%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.325928%, 67.671204%, 23.965454%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.118408%, 67.532349%, 23.954773%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.910889%, 67.393494%, 23.944092%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.703369%, 67.254639%, 23.933411%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.49585%, 67.11731%, 23.924255%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.28833%, 66.978455%, 23.913574%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.080811%, 66.841125%, 23.902893%)",
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.873291%, 66.702271%, 23.892212%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.665771%, 66.563416%, 23.883057%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.456726%, 66.424561%, 23.872375%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.249207%, 66.287231%, 23.861694%)",
    offset: 0.226563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.041687%, 66.148376%, 23.851013%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.834167%, 66.009521%, 23.840332%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.626648%, 65.870667%, 23.829651%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.419128%, 65.733337%, 23.820496%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.211609%, 65.594482%, 23.809814%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.004089%, 65.455627%, 23.799133%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.79657%, 65.316772%, 23.788452%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.58905%, 65.179443%, 23.779297%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.381531%, 65.040588%, 23.768616%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.174011%, 64.901733%, 23.757935%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.966492%, 64.762878%, 23.747253%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.758972%, 64.625549%, 23.738098%)",
    offset: 0.273437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.551453%, 64.486694%, 23.727417%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.343933%, 64.347839%, 23.716736%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.136414%, 64.208984%, 23.706055%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.928894%, 64.071655%, 23.696899%)",
    offset: 0.289063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.719849%, 63.9328%, 23.686218%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.512329%, 63.793945%, 23.675537%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.30481%, 63.65509%, 23.664856%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.09729%, 63.517761%, 23.655701%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.889771%, 63.378906%, 23.64502%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.682251%, 63.241577%, 23.634338%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.474731%, 63.102722%, 23.623657%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.267212%, 62.963867%, 23.614502%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.059692%, 62.825012%, 23.603821%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.852173%, 62.687683%, 23.59314%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.644653%, 62.548828%, 23.582458%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.437134%, 62.409973%, 23.573303%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.229614%, 62.271118%, 23.562622%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.022095%, 62.133789%, 23.551941%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.814575%, 61.994934%, 23.54126%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.607056%, 61.856079%, 23.530579%)",
    offset: 0.351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.399536%, 61.717224%, 23.519897%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.192017%, 61.579895%, 23.510742%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.982971%, 61.44104%, 23.500061%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.775452%, 61.302185%, 23.48938%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.567932%, 61.16333%, 23.478699%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.360413%, 61.026001%, 23.469543%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.152893%, 60.887146%, 23.458862%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.945374%, 60.748291%, 23.448181%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.737854%, 60.609436%, 23.4375%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.530334%, 60.472107%, 23.428345%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.322815%, 60.333252%, 23.417664%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.115295%, 60.195923%, 23.406982%)",
    offset: 0.398437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.907776%, 60.057068%, 23.396301%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.700256%, 59.918213%, 23.387146%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.492737%, 59.779358%, 23.376465%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.285217%, 59.642029%, 23.365784%)",
    offset: 0.414063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.077698%, 59.503174%, 23.355103%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.870178%, 59.364319%, 23.345947%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.662659%, 59.225464%, 23.335266%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.455139%, 59.088135%, 23.324585%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.246094%, 58.94928%, 23.313904%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.038574%, 58.810425%, 23.304749%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.831055%, 58.67157%, 23.294067%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.623535%, 58.534241%, 23.283386%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.416016%, 58.395386%, 23.272705%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.208496%, 58.256531%, 23.26355%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.000977%, 58.117676%, 23.252869%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.793457%, 57.980347%, 23.242188%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.585938%, 57.841492%, 23.231506%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.378418%, 57.702637%, 23.220825%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.170898%, 57.563782%, 23.210144%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.963379%, 57.426453%, 23.200989%)",
    offset: 0.476563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.755859%, 57.287598%, 23.190308%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.54834%, 57.148743%, 23.179626%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.34082%, 57.009888%, 23.168945%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.133301%, 56.872559%, 23.15979%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.925781%, 56.733704%, 23.149109%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.718262%, 56.596375%, 23.138428%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.509216%, 56.45752%, 23.127747%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.301697%, 56.318665%, 23.118591%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.094177%, 56.17981%, 23.10791%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.886658%, 56.04248%, 23.097229%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.679138%, 55.903625%, 23.086548%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.471619%, 55.764771%, 23.077393%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.264099%, 55.625916%, 23.066711%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.05658%, 55.488586%, 23.05603%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.84906%, 55.349731%, 23.045349%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.641541%, 55.210876%, 23.036194%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.434021%, 55.072021%, 23.025513%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.226501%, 54.934692%, 23.014832%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.018982%, 54.795837%, 23.00415%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.811462%, 54.656982%, 22.994995%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.603943%, 54.518127%, 22.984314%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.396423%, 54.380798%, 22.973633%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.188904%, 54.241943%, 22.962952%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.981384%, 54.103088%, 22.953796%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.772339%, 53.964233%, 22.943115%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.564819%, 53.826904%, 22.932434%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.3573%, 53.688049%, 22.921753%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.14978%, 53.55072%, 22.911072%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.942261%, 53.411865%, 22.900391%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.734741%, 53.27301%, 22.891235%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.527222%, 53.134155%, 22.880554%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.319702%, 52.996826%, 22.869873%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.112183%, 52.857971%, 22.859192%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.904663%, 52.719116%, 22.850037%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.697144%, 52.580261%, 22.839355%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.489624%, 52.442932%, 22.828674%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.282104%, 52.304077%, 22.817993%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.074585%, 52.165222%, 22.808838%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.867065%, 52.026367%, 22.798157%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.659546%, 51.889038%, 22.787476%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.4505%, 51.750183%, 22.776794%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.242981%, 51.611328%, 22.767639%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.035461%, 51.472473%, 22.756958%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.827942%, 51.335144%, 22.746277%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.620422%, 51.196289%, 22.735596%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.412903%, 51.057434%, 22.72644%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.205383%, 50.918579%, 22.715759%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.997864%, 50.78125%, 22.705078%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.790344%, 50.642395%, 22.694397%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.582825%, 50.505066%, 22.685242%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.375305%, 50.366211%, 22.674561%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.167786%, 50.227356%, 22.663879%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.960266%, 50.088501%, 22.653198%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.752747%, 49.951172%, 22.644043%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.545227%, 49.812317%, 22.633362%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.337708%, 49.673462%, 22.622681%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.130188%, 49.534607%, 22.612%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.922668%, 49.397278%, 22.601318%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.713623%, 49.258423%, 22.590637%)",
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.506104%, 49.119568%, 22.581482%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.298584%, 48.980713%, 22.570801%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.091064%, 48.843384%, 22.56012%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.883545%, 48.704529%, 22.549438%)",
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.676025%, 48.565674%, 22.540283%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.468506%, 48.426819%, 22.529602%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.260986%, 48.28949%, 22.518921%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.053467%, 48.150635%, 22.50824%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.845947%, 48.01178%, 22.499084%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.638428%, 47.872925%, 22.488403%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.430908%, 47.735596%, 22.477722%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.223389%, 47.596741%, 22.467041%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.015869%, 47.457886%, 22.457886%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.80835%, 47.319031%, 22.447205%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.60083%, 47.181702%, 22.436523%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.393311%, 47.042847%, 22.425842%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.185791%, 46.905518%, 22.416687%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.976746%, 46.766663%, 22.406006%)",
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.769226%, 46.627808%, 22.395325%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.561707%, 46.488953%, 22.384644%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.354187%, 46.351624%, 22.375488%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.146667%, 46.212769%, 22.364807%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.939148%, 46.073914%, 22.354126%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.731628%, 45.935059%, 22.343445%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.524109%, 45.797729%, 22.332764%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.316589%, 45.658875%, 22.322083%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.10907%, 45.52002%, 22.312927%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.90155%, 45.381165%, 22.302246%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.694031%, 45.243835%, 22.291565%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.486511%, 45.10498%, 22.280884%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.278992%, 44.966125%, 22.271729%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.071472%, 44.827271%, 22.261047%)",
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.863953%, 44.689941%, 22.250366%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.656433%, 44.551086%, 22.239685%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.448914%, 44.412231%, 22.23053%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.239868%, 44.273376%, 22.219849%)",
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.032349%, 44.136047%, 22.209167%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.824829%, 43.997192%, 22.198486%)",
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.61731%, 43.859863%, 22.189331%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.40979%, 43.721008%, 22.17865%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.202271%, 43.582153%, 22.167969%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.994751%, 43.443298%, 22.157288%)",
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.787231%, 43.305969%, 22.148132%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.579712%, 43.167114%, 22.137451%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.372192%, 43.028259%, 22.12677%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.164673%, 42.889404%, 22.116089%)",
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.957153%, 42.752075%, 22.106934%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.749634%, 42.61322%, 22.096252%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.542114%, 42.474365%, 22.085571%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.334595%, 42.33551%, 22.07489%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.127075%, 42.198181%, 22.065735%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.919556%, 42.059326%, 22.055054%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.712036%, 41.920471%, 22.044373%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.502991%, 41.781616%, 22.033691%)",
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.295471%, 41.644287%, 22.02301%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.087952%, 41.505432%, 22.012329%)",
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.880432%, 41.366577%, 22.003174%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.672913%, 41.227722%, 21.992493%)",
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.465393%, 41.090393%, 21.981812%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.257874%, 40.951538%, 21.97113%)",
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.050354%, 40.812683%, 21.961975%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.0244141%, 40.795898%, 21.960449%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 40.779114%, 21.958923%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 40.779114%, 21.958923%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c5a9e245fa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 277 655 L 1109 655 L 1109 1100 L 277 1100 Z M 277 655 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ec9d644780"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 277.078125 670.890625 C 277.078125 673.488281 277.078125 675.222656 277.078125 677.824219 C 395.828125 686.492188 558.785156 745.433594 719.136719 838.179688 C 860.421875 920.523438 972.238281 1013.269531 1034.648438 1099.945312 C 1060.648438 1084.34375 1085.785156 1066.140625 1108.324219 1046.207031 C 912.429688 814.773438 595.1875 664.820312 277.078125 655.285156 C 277.945312 659.621094 277.078125 665.6875 277.078125 670.890625 Z M 277.078125 670.890625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 71.273274,
    gradientTransform: "matrix(8.667815, 0, 0, 8.667815, -255.991025, -277.370088)",
    y1: 96.627405,
    x2: 150.227931,
    gradientUnits: "userSpaceOnUse",
    y2: 166.952186,
    id: "4f7c03154a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.34375%, 75.68512%, 24.562073%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.120972%, 75.535583%, 24.551392%)",
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.898193%, 75.387573%, 24.54071%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.675415%, 75.239563%, 24.528503%)",
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.452637%, 75.091553%, 24.517822%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.229858%, 74.942017%, 24.507141%)",
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.00708%, 74.794006%, 24.49646%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.784302%, 74.64447%, 24.484253%)",
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.563049%, 74.49646%, 24.473572%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.340271%, 74.34845%, 24.462891%)",
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.117493%, 74.200439%, 24.452209%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.894714%, 74.050903%, 24.440002%)",
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.671936%, 73.902893%, 24.429321%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.449158%, 73.754883%, 24.41864%)",
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.226379%, 73.606873%, 24.407959%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.003601%, 73.457336%, 24.395752%)",
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.780823%, 73.309326%, 24.385071%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.558044%, 73.15979%, 24.37439%)",
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.335266%, 73.01178%, 24.363708%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.112488%, 72.86377%, 24.351501%)",
    offset: 0.0742187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.889709%, 72.715759%, 24.34082%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.666931%, 72.566223%, 24.330139%)",
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.444153%, 72.418213%, 24.319458%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.221375%, 72.268677%, 24.307251%)",
    offset: 0.0898437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.000122%, 72.120667%, 24.29657%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.777344%, 71.972656%, 24.285889%)",
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.554565%, 71.824646%, 24.275208%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.331787%, 71.67511%, 24.263%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.109009%, 71.5271%, 24.252319%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.88623%, 71.377563%, 24.241638%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.663452%, 71.229553%, 24.230957%)",
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.440674%, 71.081543%, 24.21875%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.217896%, 70.933533%, 24.208069%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.995117%, 70.783997%, 24.197388%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.772339%, 70.635986%, 24.186707%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.549561%, 70.487976%, 24.1745%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.326782%, 70.339966%, 24.163818%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.104004%, 70.19043%, 24.153137%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.882751%, 70.042419%, 24.142456%)",
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.659973%, 69.892883%, 24.130249%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.437195%, 69.744873%, 24.119568%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.214417%, 69.596863%, 24.108887%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.991638%, 69.448853%, 24.098206%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.76886%, 69.299316%, 24.085999%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.546082%, 69.151306%, 24.075317%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.323303%, 69.00177%, 24.064636%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.100525%, 68.85376%, 24.053955%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.877747%, 68.70575%, 24.041748%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.654968%, 68.557739%, 24.031067%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.43219%, 68.408203%, 24.020386%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.209412%, 68.260193%, 24.009705%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.986633%, 68.112183%, 23.997498%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.763855%, 67.964172%, 23.986816%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.541077%, 67.814636%, 23.974609%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.319824%, 67.666626%, 23.963928%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.097046%, 67.51709%, 23.953247%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.874268%, 67.36908%, 23.942566%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.651489%, 67.221069%, 23.930359%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.428711%, 67.073059%, 23.919678%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.205933%, 66.923523%, 23.908997%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.983154%, 66.775513%, 23.898315%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.760376%, 66.625977%, 23.886108%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.537598%, 66.477966%, 23.875427%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.314819%, 66.329956%, 23.864746%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.092041%, 66.181946%, 23.854065%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.869263%, 66.03241%, 23.841858%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.646484%, 65.884399%, 23.831177%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.423706%, 65.734863%, 23.820496%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.200928%, 65.586853%, 23.809814%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.978149%, 65.438843%, 23.797607%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.756897%, 65.290833%, 23.786926%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.534119%, 65.141296%, 23.776245%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.31134%, 64.993286%, 23.765564%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.088562%, 64.845276%, 23.753357%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.865784%, 64.697266%, 23.742676%)",
    offset: 0.289063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.643005%, 64.547729%, 23.731995%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.420227%, 64.399719%, 23.721313%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.197449%, 64.250183%, 23.709106%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.97467%, 64.102173%, 23.698425%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.751892%, 63.954163%, 23.687744%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.529114%, 63.806152%, 23.677063%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.306335%, 63.656616%, 23.664856%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.083557%, 63.508606%, 23.654175%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.860779%, 63.35907%, 23.643494%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.638%, 63.21106%, 23.632812%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.415222%, 63.063049%, 23.620605%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.19397%, 62.915039%, 23.609924%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.971191%, 62.765503%, 23.599243%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.748413%, 62.617493%, 23.588562%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.525635%, 62.467957%, 23.576355%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.302856%, 62.319946%, 23.565674%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.080078%, 62.171936%, 23.554993%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.8573%, 62.023926%, 23.544312%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.634521%, 61.87439%, 23.532104%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.411743%, 61.726379%, 23.521423%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.188965%, 61.578369%, 23.510742%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.966187%, 61.430359%, 23.500061%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.743408%, 61.280823%, 23.487854%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.52063%, 61.132812%, 23.477173%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.297852%, 60.983276%, 23.466492%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.075073%, 60.835266%, 23.455811%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.852295%, 60.687256%, 23.443604%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.631042%, 60.539246%, 23.432922%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.408264%, 60.389709%, 23.422241%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.185486%, 60.241699%, 23.41156%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.962708%, 60.092163%, 23.399353%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.739929%, 59.944153%, 23.388672%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.517151%, 59.796143%, 23.377991%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.294373%, 59.648132%, 23.36731%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.071594%, 59.498596%, 23.355103%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.848816%, 59.350586%, 23.344421%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.626038%, 59.20105%, 23.332214%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.403259%, 59.05304%, 23.321533%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.180481%, 58.905029%, 23.310852%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.957703%, 58.757019%, 23.300171%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.734924%, 58.607483%, 23.287964%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.512146%, 58.459473%, 23.277283%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.289368%, 58.311462%, 23.266602%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.068115%, 58.163452%, 23.25592%)",
    offset: 0.460937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.845337%, 58.013916%, 23.243713%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.622559%, 57.865906%, 23.233032%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.39978%, 57.71637%, 23.222351%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.177002%, 57.568359%, 23.21167%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.954224%, 57.420349%, 23.199463%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.731445%, 57.272339%, 23.188782%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.508667%, 57.122803%, 23.178101%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.285889%, 56.974792%, 23.167419%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.06311%, 56.825256%, 23.155212%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.840332%, 56.677246%, 23.144531%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.617554%, 56.529236%, 23.13385%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.394775%, 56.381226%, 23.123169%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.171997%, 56.231689%, 23.110962%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.949219%, 56.083679%, 23.100281%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.72644%, 55.934143%, 23.0896%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.505188%, 55.786133%, 23.078918%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.28241%, 55.638123%, 23.066711%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.059631%, 55.490112%, 23.05603%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.836853%, 55.340576%, 23.045349%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.614075%, 55.192566%, 23.034668%)",
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.391296%, 55.044556%, 23.022461%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.168518%, 54.896545%, 23.01178%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.94574%, 54.747009%, 23.001099%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.722961%, 54.598999%, 22.990417%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.500183%, 54.449463%, 22.97821%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.277405%, 54.301453%, 22.967529%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.054626%, 54.153442%, 22.956848%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.831848%, 54.005432%, 22.946167%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.60907%, 53.855896%, 22.93396%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.386292%, 53.707886%, 22.923279%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.163513%, 53.55835%, 22.912598%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.942261%, 53.410339%, 22.901917%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.719482%, 53.262329%, 22.889709%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.496704%, 53.114319%, 22.879028%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.273926%, 52.964783%, 22.868347%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.051147%, 52.816772%, 22.857666%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.828369%, 52.667236%, 22.845459%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.605591%, 52.519226%, 22.834778%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.382812%, 52.371216%, 22.824097%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.160034%, 52.223206%, 22.813416%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.937256%, 52.073669%, 22.801208%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.714478%, 51.925659%, 22.790527%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.491699%, 51.777649%, 22.779846%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.268921%, 51.629639%, 22.769165%)",
    offset: 0.632813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.046143%, 51.480103%, 22.756958%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.823364%, 51.332092%, 22.746277%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.600586%, 51.182556%, 22.735596%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.379333%, 51.034546%, 22.724915%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.156555%, 50.886536%, 22.712708%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.933777%, 50.738525%, 22.702026%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.710999%, 50.588989%, 22.689819%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.48822%, 50.440979%, 22.679138%)",
    offset: 0.664063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.265442%, 50.291443%, 22.668457%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.042664%, 50.143433%, 22.657776%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.819885%, 49.995422%, 22.645569%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.597107%, 49.847412%, 22.634888%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.374329%, 49.697876%, 22.624207%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.15155%, 49.549866%, 22.613525%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.928772%, 49.40033%, 22.601318%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.705994%, 49.252319%, 22.590637%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.483215%, 49.104309%, 22.579956%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.260437%, 48.956299%, 22.569275%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.037659%, 48.806763%, 22.557068%)",
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.816406%, 48.658752%, 22.546387%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.593628%, 48.510742%, 22.535706%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.37085%, 48.362732%, 22.525024%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.148071%, 48.213196%, 22.512817%)",
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.925293%, 48.065186%, 22.502136%)",
    offset: 0.726563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.702515%, 47.915649%, 22.491455%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.479736%, 47.767639%, 22.480774%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.256958%, 47.619629%, 22.468567%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.03418%, 47.471619%, 22.457886%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.811401%, 47.322083%, 22.447205%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.588623%, 47.174072%, 22.436523%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.365845%, 47.024536%, 22.424316%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.143066%, 46.876526%, 22.413635%)",
    offset: 0.757813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.920288%, 46.728516%, 22.402954%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.69751%, 46.580505%, 22.392273%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.474731%, 46.430969%, 22.380066%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.253479%, 46.282959%, 22.369385%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.030701%, 46.133423%, 22.358704%)",
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.807922%, 45.985413%, 22.348022%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.585144%, 45.837402%, 22.335815%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.362366%, 45.689392%, 22.325134%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.139587%, 45.539856%, 22.314453%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.916809%, 45.391846%, 22.303772%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.694031%, 45.243835%, 22.291565%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.471252%, 45.095825%, 22.280884%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.248474%, 44.946289%, 22.270203%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.025696%, 44.798279%, 22.259521%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.802917%, 44.648743%, 22.247314%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.580139%, 44.500732%, 22.236633%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.357361%, 44.352722%, 22.225952%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.134583%, 44.204712%, 22.215271%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.911804%, 44.055176%, 22.203064%)",
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.690552%, 43.907166%, 22.192383%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.467773%, 43.757629%, 22.181702%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.244995%, 43.609619%, 22.171021%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.022217%, 43.461609%, 22.158813%)",
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.799438%, 43.313599%, 22.148132%)",
    offset: 0.851563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.57666%, 43.164062%, 22.137451%)",
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.353882%, 43.016052%, 22.12677%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.131104%, 42.866516%, 22.114563%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.908325%, 42.718506%, 22.103882%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.685547%, 42.570496%, 22.093201%)",
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.462769%, 42.422485%, 22.08252%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.23999%, 42.272949%, 22.070312%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.017212%, 42.124939%, 22.059631%)",
    offset: 0.882813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.794434%, 41.976929%, 22.047424%)",
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.571655%, 41.828918%, 22.036743%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.348877%, 41.679382%, 22.026062%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.127625%, 41.531372%, 22.015381%)",
    offset: 0.898437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.904846%, 41.381836%, 22.003174%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.682068%, 41.233826%, 21.992493%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.45929%, 41.085815%, 21.981812%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.236511%, 40.937805%, 21.97113%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.117493%, 40.858459%, 21.965027%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 40.779114%, 21.958923%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 40.779114%, 21.958923%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dbe907e3ce"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 617,
    y: 0,
    height: 268
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6e3189cf7b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#adeb99e5a4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a2b87fc3b2)",
    d: "M 1068.449219 852.046875 L 1068.449219 1029.738281 L 1243.539062 1029.738281 L 1243.539062 852.046875 Z M 1068.449219 852.046875 ",
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7bddf627ac)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a46c8ed738)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#7f21786d99)",
    d: "M 989.574219 771.433594 L 989.574219 949.125 L 1266.078125 949.125 L 1266.078125 771.433594 Z M 989.574219 771.433594 ",
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e79e4051e7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2c2554f89c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#6124579b3c)",
    d: "M 901.164062 702.960938 L 901.164062 879.78125 L 1274.746094 879.78125 L 1274.746094 702.960938 Z M 901.164062 702.960938 ",
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8aa83ff1ac)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3e938ebae2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ae0df2612f)",
    d: "M 804.949219 654.421875 L 804.949219 814.773438 L 1275.613281 814.773438 L 1275.613281 654.421875 Z M 804.949219 654.421875 ",
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fe51a15df9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#13c290cf21)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#1480a00c60)",
    d: "M 310.882812 851.179688 L 310.882812 1154.554688 L 648.0625 1154.554688 L 648.0625 851.179688 Z M 310.882812 851.179688 ",
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#12b6fe9c6a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5a1d2137f0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#6879027539)",
    d: "M 287.480469 771.433594 L 287.480469 1171.023438 L 849.15625 1171.023438 L 849.15625 771.433594 Z M 287.480469 771.433594 ",
    fillRule: "nonzero"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b49103cfb0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#913989b0b2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#7178b202e8)",
    d: "M 278.8125 702.960938 L 278.8125 1162.355469 L 1013.84375 1162.355469 L 1013.84375 702.960938 Z M 278.8125 702.960938 ",
    fillRule: "nonzero"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c5a9e245fa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ec9d644780)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#4f7c03154a)",
    d: "M 277.078125 655.285156 L 277.078125 1099.945312 L 1108.324219 1099.945312 L 1108.324219 655.285156 Z M 277.078125 655.285156 ",
    fillRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 797.148438 350.179688 C 797.148438 365.78125 790.214844 379.648438 779.8125 389.183594 C 769.410156 378.785156 762.476562 364.914062 762.476562 350.179688 C 762.476562 334.578125 769.410156 320.710938 779.8125 311.175781 C 790.214844 321.574219 797.148438 334.578125 797.148438 350.179688 Z M 797.148438 350.179688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 752.074219 662.222656 C 768.542969 678.691406 776.347656 700.359375 775.480469 722.027344 C 752.941406 722.894531 731.273438 715.09375 715.671875 698.625 C 699.203125 682.15625 691.402344 660.488281 692.269531 638.816406 C 713.9375 638.816406 736.472656 645.753906 752.074219 662.222656 Z M 752.074219 662.222656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 754.675781 595.480469 C 769.410156 611.082031 775.480469 631.882812 774.613281 652.6875 C 753.808594 652.6875 733.875 644.886719 719.136719 629.285156 C 704.402344 613.679688 698.335938 592.878906 699.203125 572.074219 C 720.003906 572.074219 739.941406 579.875 754.675781 595.480469 Z M 754.675781 595.480469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 756.410156 527.871094 C 769.410156 542.605469 774.613281 562.542969 772.878906 581.609375 C 753.808594 580.742188 734.738281 572.941406 721.738281 557.339844 C 708.738281 542.605469 703.535156 522.667969 705.269531 503.601562 C 725.207031 505.332031 743.40625 513.132812 756.410156 527.871094 Z M 756.410156 527.871094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 758.144531 461.128906 C 769.410156 475.863281 773.746094 494.066406 771.144531 511.402344 C 752.941406 509.667969 736.472656 501.867188 725.207031 487.132812 C 713.9375 472.394531 709.601562 454.195312 712.203125 436.859375 C 730.40625 438.589844 746.875 446.390625 758.144531 461.128906 Z M 758.144531 461.128906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 759.875 393.519531 C 769.410156 407.386719 772.878906 424.722656 769.410156 441.191406 C 752.941406 438.589844 738.207031 430.789062 727.804688 416.054688 C 718.269531 402.1875 714.804688 384.851562 718.269531 368.382812 C 735.605469 371.847656 750.34375 379.648438 759.875 393.519531 Z M 759.875 393.519531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 807.550781 662.222656 C 791.082031 678.691406 783.28125 700.359375 784.148438 722.027344 C 806.683594 722.894531 828.351562 715.09375 843.953125 698.625 C 860.421875 682.15625 868.222656 660.488281 867.359375 638.816406 C 844.820312 638.816406 823.152344 645.753906 807.550781 662.222656 Z M 807.550781 662.222656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 804.949219 595.480469 C 790.214844 611.082031 784.148438 631.882812 785.011719 652.6875 C 805.816406 652.6875 825.753906 644.886719 840.488281 629.285156 C 855.222656 613.679688 861.289062 592.878906 860.421875 572.074219 C 839.621094 572.074219 819.683594 579.875 804.949219 595.480469 Z M 804.949219 595.480469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 803.214844 527.871094 C 790.214844 542.605469 785.011719 562.542969 786.746094 581.609375 C 805.816406 580.742188 824.886719 572.941406 837.886719 557.339844 C 850.890625 542.605469 856.089844 522.667969 854.355469 503.601562 C 834.421875 505.332031 816.21875 513.132812 803.214844 527.871094 Z M 803.214844 527.871094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 801.480469 461.128906 C 790.214844 475.863281 785.878906 494.066406 788.480469 511.402344 C 806.683594 509.667969 823.152344 501.867188 834.421875 487.132812 C 845.6875 472.394531 850.023438 454.195312 847.421875 436.859375 C 829.21875 438.589844 812.75 446.390625 801.480469 461.128906 Z M 801.480469 461.128906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 798.882812 393.519531 C 789.347656 407.386719 785.878906 424.722656 789.347656 441.191406 C 805.816406 438.589844 820.550781 430.789062 830.953125 416.054688 C 840.488281 402.1875 843.953125 384.851562 840.488281 368.382812 C 824.019531 371.847656 809.285156 379.648438 798.882812 393.519531 Z M 798.882812 393.519531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 975.707031 393.519531 C 975.707031 403.921875 971.371094 414.320312 963.570312 421.253906 C 955.769531 414.320312 951.4375 403.921875 951.4375 393.519531 C 951.4375 383.117188 955.769531 372.714844 963.570312 365.78125 C 971.371094 372.714844 975.707031 383.117188 975.707031 393.519531 Z M 975.707031 393.519531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 944.5 612.816406 C 955.769531 624.082031 960.96875 639.683594 960.96875 655.285156 C 945.367188 655.285156 929.765625 650.085938 918.496094 638.816406 C 907.230469 627.550781 902.027344 611.949219 902.027344 596.34375 C 917.632812 595.480469 933.234375 600.679688 944.5 612.816406 Z M 944.5 612.816406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 946.234375 565.140625 C 956.636719 576.410156 960.96875 590.277344 960.101562 605.011719 C 945.367188 605.011719 931.5 599.8125 921.097656 588.542969 C 910.695312 577.277344 906.363281 563.40625 907.230469 548.671875 C 921.097656 548.671875 935.832031 554.738281 946.234375 565.140625 Z M 946.234375 565.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 947.101562 518.335938 C 956.636719 528.738281 960.101562 542.605469 958.371094 556.472656 C 944.5 555.605469 931.5 550.40625 922.832031 540.003906 C 913.296875 529.601562 909.828125 515.734375 911.5625 501.867188 C 925.433594 501.867188 938.433594 507.933594 947.101562 518.335938 Z M 947.101562 518.335938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 948.835938 470.664062 C 956.636719 481.0625 960.101562 493.199219 958.371094 506.199219 C 945.367188 505.332031 934.101562 499.265625 926.300781 488.863281 C 918.496094 478.464844 915.03125 466.328125 916.765625 453.328125 C 928.898438 455.058594 940.167969 461.128906 948.835938 470.664062 Z M 948.835938 470.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 949.703125 423.855469 C 956.636719 433.390625 958.371094 445.527344 956.636719 456.792969 C 945.367188 455.058594 934.101562 448.992188 927.164062 439.457031 C 920.230469 429.921875 918.496094 417.789062 920.230469 406.519531 C 932.367188 408.253906 942.769531 414.320312 949.703125 423.855469 Z M 949.703125 423.855469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 982.640625 612.816406 C 971.371094 624.082031 966.171875 639.683594 966.171875 655.285156 C 981.773438 655.285156 997.375 650.085938 1008.644531 638.816406 C 1019.910156 627.550781 1025.113281 611.949219 1025.113281 596.34375 C 1009.511719 595.480469 993.90625 600.679688 982.640625 612.816406 Z M 982.640625 612.816406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 981.773438 565.140625 C 971.371094 576.410156 967.039062 590.277344 967.90625 605.011719 C 982.640625 605.011719 996.507812 599.8125 1006.910156 588.542969 C 1017.3125 577.277344 1021.644531 563.40625 1020.777344 548.671875 C 1006.042969 548.671875 992.175781 554.738281 981.773438 565.140625 Z M 981.773438 565.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 980.039062 518.335938 C 970.503906 528.738281 967.039062 542.605469 968.769531 556.472656 C 982.640625 555.605469 995.640625 550.40625 1004.308594 540.003906 C 1013.84375 529.601562 1017.3125 515.734375 1015.578125 501.867188 C 1002.574219 501.867188 989.574219 507.933594 980.039062 518.335938 Z M 980.039062 518.335938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 978.304688 470.664062 C 970.503906 481.0625 967.039062 493.199219 968.769531 506.199219 C 981.773438 505.332031 993.039062 499.265625 1000.84375 488.863281 C 1008.644531 478.464844 1012.109375 466.328125 1010.375 453.328125 C 998.242188 455.058594 986.972656 461.128906 978.304688 470.664062 Z M 978.304688 470.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 977.4375 423.855469 C 970.503906 433.390625 968.769531 445.527344 970.503906 456.792969 C 981.773438 455.058594 993.042969 448.992188 999.976562 439.457031 C 1006.910156 429.921875 1008.644531 417.789062 1006.910156 406.519531 C 994.773438 408.253906 984.375 414.320312 977.4375 423.855469 Z M 977.4375 423.855469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 1117.859375 427.324219 C 1117.859375 435.125 1114.390625 442.058594 1109.191406 447.257812 C 1103.988281 442.058594 1100.523438 435.125 1100.523438 427.324219 C 1100.523438 419.523438 1103.988281 412.589844 1109.191406 407.386719 C 1114.390625 412.589844 1117.859375 419.523438 1117.859375 427.324219 Z M 1117.859375 427.324219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 1094.453125 587.679688 C 1103.121094 596.34375 1106.589844 606.746094 1106.589844 618.882812 C 1095.320312 618.882812 1084.054688 615.414062 1075.386719 606.746094 C 1066.71875 598.078125 1063.25 587.679688 1063.25 575.542969 C 1075.386719 575.542969 1086.652344 579.011719 1094.453125 587.679688 Z M 1094.453125 587.679688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 1095.320312 553.007812 C 1103.121094 560.808594 1106.589844 571.210938 1105.722656 582.476562 C 1095.320312 582.476562 1084.917969 578.144531 1077.117188 570.34375 C 1069.316406 562.542969 1065.851562 552.140625 1066.71875 540.871094 C 1077.984375 540.871094 1088.386719 545.207031 1095.320312 553.007812 Z M 1095.320312 553.007812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 1096.1875 518.335938 C 1103.121094 526.136719 1105.722656 535.671875 1104.855469 546.074219 C 1095.320312 545.207031 1085.785156 541.738281 1078.851562 533.9375 C 1071.917969 526.136719 1069.316406 516.601562 1070.183594 506.199219 C 1080.585938 507.066406 1090.121094 510.535156 1096.1875 518.335938 Z M 1096.1875 518.335938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 1097.921875 484.53125 C 1103.988281 492.332031 1105.722656 501 1104.855469 510.535156 C 1095.320312 509.667969 1086.652344 505.332031 1081.453125 498.398438 C 1075.386719 490.597656 1073.652344 481.929688 1074.519531 472.394531 C 1083.1875 472.394531 1091.855469 476.730469 1097.921875 484.53125 Z M 1097.921875 484.53125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 1098.789062 449.859375 C 1103.988281 456.792969 1105.722656 465.460938 1103.988281 474.128906 C 1095.320312 473.261719 1087.519531 468.929688 1082.320312 461.128906 C 1077.117188 454.195312 1075.386719 445.527344 1077.117188 436.859375 C 1085.785156 438.589844 1093.585938 442.058594 1098.789062 449.859375 Z M 1098.789062 449.859375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 1123.058594 587.679688 C 1114.390625 596.34375 1110.921875 606.746094 1110.921875 618.882812 C 1122.191406 618.882812 1133.460938 615.414062 1142.128906 606.746094 C 1150.796875 598.078125 1154.261719 587.679688 1154.261719 575.542969 C 1142.128906 575.542969 1130.859375 579.011719 1123.058594 587.679688 Z M 1123.058594 587.679688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 1121.324219 553.007812 C 1113.523438 560.808594 1110.054688 571.210938 1110.921875 582.476562 C 1121.324219 582.476562 1131.726562 578.144531 1139.527344 570.34375 C 1147.328125 562.542969 1150.796875 552.140625 1149.929688 540.871094 C 1139.527344 540.871094 1129.125 545.207031 1121.324219 553.007812 Z M 1121.324219 553.007812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 1120.457031 518.335938 C 1113.523438 526.136719 1110.921875 535.671875 1111.789062 546.074219 C 1121.324219 545.207031 1130.859375 541.738281 1137.792969 533.9375 C 1144.726562 526.136719 1147.328125 516.601562 1146.460938 506.199219 C 1136.925781 507.066406 1127.390625 510.535156 1120.457031 518.335938 Z M 1120.457031 518.335938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 1119.589844 484.53125 C 1113.523438 492.332031 1111.789062 501 1112.65625 510.535156 C 1122.191406 509.667969 1130.859375 505.332031 1136.058594 498.398438 C 1142.128906 490.597656 1143.859375 481.929688 1142.996094 472.394531 C 1134.328125 472.394531 1125.660156 476.730469 1119.589844 484.53125 Z M 1119.589844 484.53125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 1118.722656 449.859375 C 1113.523438 456.792969 1111.789062 465.460938 1113.523438 474.128906 C 1122.191406 473.261719 1129.992188 468.929688 1135.191406 461.128906 C 1140.394531 454.195312 1142.128906 445.527344 1140.394531 436.859375 C 1131.726562 438.589844 1123.925781 442.058594 1118.722656 449.859375 Z M 1118.722656 449.859375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 399.296875 511.402344 C 348.15625 514 303.082031 539.136719 271.011719 577.277344 C 307.417969 611.082031 355.089844 631.015625 406.230469 628.417969 C 457.371094 625.816406 502.441406 600.679688 534.515625 562.542969 C 498.109375 527.871094 450.4375 508.800781 399.296875 511.402344 Z M 399.296875 511.402344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 445.234375 496.664062 C 401.03125 499.265625 360.289062 482.796875 328.21875 454.195312 C 355.957031 421.253906 394.09375 399.585938 438.300781 396.984375 C 482.507812 394.386719 523.246094 410.855469 555.316406 439.457031 C 528.445312 472.394531 489.441406 494.066406 445.234375 496.664062 Z M 445.234375 496.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 307.417969 237.5 C 311.75 276.503906 297.882812 312.90625 273.613281 341.511719 C 244.140625 318.109375 223.339844 285.171875 219.871094 246.164062 C 215.539062 207.160156 229.40625 170.757812 253.675781 142.152344 C 283.148438 165.554688 303.949219 198.492188 307.417969 237.5 Z M 307.417969 237.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 219.003906 324.175781 C 233.742188 364.914062 230.273438 408.253906 211.203125 446.390625 C 172.199219 429.921875 140.996094 399.585938 126.257812 358.847656 C 111.523438 318.109375 114.992188 274.769531 134.0625 236.632812 C 173.066406 253.101562 204.269531 283.4375 219.003906 324.175781 Z M 219.003906 324.175781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 130.59375 420.390625 C 162.664062 456.792969 176.53125 504.464844 172.199219 552.140625 C 124.527344 550.40625 79.453125 531.335938 46.515625 494.933594 C 14.445312 458.527344 0.578125 410.855469 4.910156 363.179688 C 52.582031 364.914062 97.65625 383.984375 130.59375 420.390625 Z M 130.59375 420.390625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 505.910156 381.382812 C 467.773438 375.316406 435.699219 352.78125 414.898438 320.710938 C 445.234375 298.171875 482.507812 286.90625 520.644531 293.839844 C 558.785156 299.90625 590.855469 322.441406 611.65625 354.511719 C 582.1875 377.050781 544.914062 388.316406 505.910156 381.382812 Z M 505.910156 381.382812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 407.097656 167.289062 C 406.230469 204.558594 388.894531 237.5 362.023438 261.769531 C 336.886719 236.632812 321.285156 201.960938 323.019531 165.554688 C 323.886719 128.285156 341.222656 95.347656 368.089844 71.074219 C 393.226562 96.210938 408.832031 130.015625 407.097656 167.289062 Z M 407.097656 167.289062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 506.777344 119.617188 C 501.574219 154.285156 482.507812 182.890625 454.769531 202.828125 C 433.96875 175.957031 423.566406 143.019531 428.765625 108.347656 C 433.96875 73.675781 453.035156 45.074219 480.773438 25.136719 C 501.574219 51.140625 511.976562 84.945312 506.777344 119.617188 Z M 506.777344 119.617188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 603.855469 93.613281 C 594.320312 123.949219 573.519531 147.351562 545.78125 161.222656 C 530.179688 134.351562 525.847656 103.148438 534.511719 72.808594 C 544.046875 42.472656 564.851562 19.070312 592.589844 5.199219 C 608.191406 32.070312 613.390625 63.273438 603.855469 93.613281 Z M 603.855469 93.613281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 593.453125 299.039062 C 566.585938 282.570312 549.25 255.699219 543.179688 225.363281 C 572.652344 217.5625 604.722656 221.027344 631.59375 237.5 C 658.464844 253.96875 675.800781 280.835938 681.867188 311.175781 C 652.394531 318.109375 620.324219 315.507812 593.453125 299.039062 Z M 593.453125 299.039062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 698.335938 82.34375 C 684.46875 108.347656 661.0625 126.550781 634.195312 134.351562 C 624.660156 107.480469 625.527344 78.011719 639.394531 52.007812 C 653.261719 26.003906 676.664062 7.800781 703.535156 0 C 712.203125 26.003906 711.335938 56.339844 698.335938 82.34375 Z M 698.335938 82.34375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 676.664062 259.167969 C 651.527344 243.566406 635.925781 218.429688 629.859375 190.691406 C 657.597656 183.757812 687.066406 186.359375 712.203125 201.960938 C 737.339844 217.5625 752.941406 242.699219 759.011719 270.4375 C 730.40625 278.238281 700.9375 274.769531 676.664062 259.167969 Z M 676.664062 259.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 784.148438 100.546875 C 765.078125 119.617188 740.808594 128.285156 714.804688 127.417969 C 713.9375 101.414062 722.605469 76.277344 741.675781 58.074219 C 760.742188 39.003906 785.011719 30.335938 811.015625 31.203125 C 811.015625 57.207031 802.347656 82.34375 784.148438 100.546875 Z M 784.148438 100.546875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 759.011719 225.363281 C 735.605469 213.226562 720.003906 191.558594 713.070312 166.421875 C 737.339844 158.621094 764.210938 159.488281 787.613281 171.621094 C 811.015625 183.757812 826.617188 205.425781 833.554688 230.5625 C 809.285156 238.363281 782.414062 237.5 759.011719 225.363281 Z M 759.011719 225.363281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 858.691406 163.820312 C 832.6875 166.421875 807.550781 156.886719 787.613281 140.417969 C 803.214844 120.484375 826.617188 106.613281 852.621094 104.015625 C 878.625 101.414062 903.761719 110.949219 923.699219 127.417969 C 908.097656 148.21875 885.558594 161.222656 858.691406 163.820312 Z M 858.691406 163.820312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b9f26",
    d: "M 760.742188 147.351562 C 654.128906 138.683594 543.179688 165.554688 449.570312 222.761719 C 355.089844 279.96875 277.945312 367.515625 232.875 469.796875 C 186.933594 572.941406 173.066406 689.957031 193.867188 801.773438 C 199.070312 829.511719 206.003906 857.246094 215.539062 884.117188 C 225.074219 910.988281 236.339844 936.992188 249.34375 962.128906 C 262.34375 987.265625 277.945312 1011.535156 294.414062 1034.070312 C 311.75 1056.605469 329.953125 1078.277344 349.890625 1099.078125 C 369.824219 1119.015625 391.496094 1137.21875 414.898438 1154.554688 C 437.433594 1171.023438 461.703125 1186.625 486.839844 1199.625 C 511.976562 1212.628906 537.980469 1223.894531 564.851562 1233.429688 C 591.722656 1242.964844 619.457031 1249.898438 647.195312 1255.097656 C 759.011719 1275.902344 876.027344 1262.035156 979.171875 1216.09375 C 1082.320312 1170.15625 1168.996094 1093.011719 1226.207031 998.53125 C 1283.414062 904.054688 1310.28125 793.105469 1301.617188 687.359375 C 1299.015625 714.226562 1295.546875 740.230469 1290.347656 766.234375 C 1284.28125 792.238281 1277.34375 817.375 1268.675781 841.644531 C 1259.144531 865.914062 1248.742188 890.183594 1236.605469 912.71875 C 1224.472656 935.257812 1210.601562 956.925781 1195 977.730469 C 1134.328125 1060.074219 1050.25 1124.214844 955.769531 1159.753906 C 932.367188 1168.421875 908.097656 1175.355469 883.828125 1181.421875 C 859.554688 1186.625 834.421875 1190.089844 810.148438 1192.691406 C 785.011719 1194.425781 760.742188 1194.425781 735.605469 1192.691406 C 710.46875 1190.957031 686.199219 1187.492188 661.929688 1182.289062 C 637.660156 1177.089844 614.257812 1170.15625 590.855469 1161.488281 C 567.453125 1152.820312 544.914062 1142.417969 523.246094 1131.148438 C 501.574219 1119.015625 480.773438 1106.011719 460.835938 1091.277344 C 440.902344 1076.542969 422.699219 1060.074219 404.496094 1042.738281 C 387.160156 1025.402344 370.691406 1006.332031 355.957031 986.398438 C 341.222656 966.460938 328.21875 945.660156 316.085938 923.988281 C 303.949219 902.320312 294.414062 879.78125 285.746094 856.378906 C 277.078125 832.976562 271.011719 809.574219 264.945312 785.304688 C 259.742188 761.035156 256.277344 736.765625 254.542969 711.628906 C 253.675781 686.492188 252.808594 662.222656 254.542969 637.085938 C 256.277344 611.949219 259.742188 587.675781 265.8125 563.40625 C 271.011719 539.136719 277.945312 514.867188 287.480469 491.464844 C 323.019531 397.851562 387.160156 313.773438 469.503906 252.234375 C 490.308594 236.632812 511.976562 223.628906 534.511719 210.628906 C 557.050781 198.492188 581.320312 188.089844 605.589844 178.558594 C 629.859375 169.023438 654.996094 162.085938 681 156.886719 C 707.871094 153.421875 734.738281 149.953125 760.742188 147.351562 Z M 760.742188 147.351562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 447, 1232)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dbe907e3ce)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ff914d",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.291255, 205.367311)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 13.515625 -16.09375 L 17.8125 -16.53125 C 19.101562 -16.675781 20.210938 -17.210938 21.140625 -18.140625 C 22.066406 -19.066406 22.53125 -20.175781 22.53125 -21.46875 L 23.390625 -126.640625 C 23.390625 -128.078125 22.890625 -129.257812 21.890625 -130.1875 C 20.890625 -131.113281 19.742188 -131.578125 18.453125 -131.578125 L 16.75 -131.578125 C 13.738281 -131.867188 12.09375 -133.515625 11.8125 -136.515625 L 11.59375 -144.890625 C 11.445312 -146.328125 11.835938 -147.546875 12.765625 -148.546875 C 13.703125 -149.546875 14.882812 -150.117188 16.3125 -150.265625 L 26.1875 -150.46875 C 26.1875 -150.46875 27.6875 -150.503906 30.6875 -150.578125 C 33.695312 -150.648438 37.457031 -150.722656 41.96875 -150.796875 C 46.476562 -150.867188 50.945312 -150.796875 55.375 -150.578125 C 59.8125 -150.367188 63.535156 -150.046875 66.546875 -149.609375 C 69.691406 -149.179688 73.195312 -148.25 77.0625 -146.8125 C 80.925781 -145.382812 84.679688 -143.3125 88.328125 -140.59375 C 91.984375 -137.875 95.171875 -134.257812 97.890625 -129.75 C 100.609375 -125.25 102.394531 -119.707031 103.25 -113.125 C 103.675781 -102.101562 102.671875 -93.015625 100.234375 -85.859375 C 97.804688 -78.703125 93.976562 -73.015625 88.75 -68.796875 C 83.53125 -64.578125 76.914062 -61.175781 68.90625 -58.59375 C 65.757812 -57.59375 62.320312 -56.945312 58.59375 -56.65625 C 54.875 -56.375 51.367188 -56.09375 48.078125 -55.8125 C 47.078125 -55.8125 46.253906 -55.453125 45.609375 -54.734375 C 44.972656 -54.023438 44.65625 -53.164062 44.65625 -52.15625 C 44.65625 -49.300781 44.65625 -45.941406 44.65625 -42.078125 C 44.65625 -38.210938 44.65625 -34.414062 44.65625 -30.6875 C 44.65625 -26.96875 44.582031 -23.820312 44.4375 -21.25 C 44.4375 -19.957031 44.898438 -18.8125 45.828125 -17.8125 C 46.753906 -16.8125 47.9375 -16.3125 49.375 -16.3125 L 54.515625 -16.09375 C 55.953125 -16.09375 57.132812 -15.59375 58.0625 -14.59375 C 58.988281 -13.59375 59.453125 -12.378906 59.453125 -10.953125 L 59.25 -4.5 C 59.25 -3.21875 58.78125 -2.109375 57.84375 -1.171875 C 56.914062 -0.242188 55.738281 0.21875 54.3125 0.21875 L 13.734375 0.21875 C 12.304688 0.21875 11.09375 -0.28125 10.09375 -1.28125 C 9.09375 -2.289062 8.59375 -3.507812 8.59375 -4.9375 L 8.796875 -11.375 C 8.941406 -12.519531 9.441406 -13.554688 10.296875 -14.484375 C 11.160156 -15.421875 12.234375 -15.957031 13.515625 -16.09375 Z M 44.859375 -127.296875 C 44.859375 -118.992188 44.859375 -110.726562 44.859375 -102.5 C 44.859375 -94.269531 44.929688 -85.929688 45.078125 -77.484375 C 45.078125 -74.765625 46.4375 -73.40625 49.15625 -73.40625 C 53.300781 -73.695312 57.695312 -74.804688 62.34375 -76.734375 C 67 -78.671875 71.046875 -81.390625 74.484375 -84.890625 C 77.921875 -88.398438 79.640625 -92.660156 79.640625 -97.671875 C 79.492188 -101.390625 79.523438 -105.109375 79.734375 -108.828125 C 79.953125 -112.546875 79.0625 -116.550781 77.0625 -120.84375 C 75.488281 -125.851562 71.984375 -129.320312 66.546875 -131.25 C 61.109375 -133.1875 55.238281 -133.582031 48.9375 -132.4375 C 46.21875 -132.007812 44.859375 -130.296875 44.859375 -127.296875 Z M 44.859375 -127.296875 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#ff914d",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(117.633351, 205.367311)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 85.640625 -15.890625 L 88.4375 -15.890625 C 90.15625 -15.890625 91.335938 -15.316406 91.984375 -14.171875 C 92.628906 -13.023438 92.953125 -11.734375 92.953125 -10.296875 L 92.953125 -4.71875 C 92.953125 -2.863281 92.34375 -1.613281 91.125 -0.96875 C 89.90625 -0.320312 88.648438 0 87.359375 0 L 69.125 0 C 67.550781 0 66.222656 -0.570312 65.140625 -1.71875 C 64.066406 -2.863281 63.460938 -4.148438 63.328125 -5.578125 C 63.179688 -6.722656 63.070312 -7.722656 63 -8.578125 C 62.925781 -9.441406 62.890625 -10.160156 62.890625 -10.734375 L 62.890625 -12.453125 C 62.742188 -12.878906 62.5625 -13.09375 62.34375 -13.09375 C 62.132812 -13.09375 61.890625 -12.878906 61.609375 -12.453125 C 60.171875 -9.878906 58.453125 -7.515625 56.453125 -5.359375 C 54.878906 -3.648438 52.800781 -2.328125 50.21875 -1.390625 C 47.644531 -0.460938 45.140625 0.175781 42.703125 0.53125 C 40.273438 0.894531 38.273438 1.078125 36.703125 1.078125 C 34.554688 1.078125 32.695312 1.078125 31.125 1.078125 C 29.550781 1.078125 27.765625 0.71875 25.765625 0 C 24.898438 -0.28125 24.070312 -0.632812 23.28125 -1.0625 C 22.5 -1.5 21.679688 -2.003906 20.828125 -2.578125 C 20.253906 -2.859375 19.460938 -3.460938 18.453125 -4.390625 C 17.453125 -5.328125 16.8125 -5.9375 16.53125 -6.21875 C 13.664062 -9.082031 11.585938 -12.769531 10.296875 -17.28125 C 9.015625 -21.789062 8.515625 -26.546875 8.796875 -31.546875 C 9.085938 -36.554688 10.019531 -41.066406 11.59375 -45.078125 C 14.738281 -52.953125 19.316406 -58.640625 25.328125 -62.140625 C 31.335938 -65.648438 38.78125 -67.472656 47.65625 -67.609375 C 50.082031 -67.609375 52.15625 -67.609375 53.875 -67.609375 C 55.59375 -67.609375 56.953125 -67.539062 57.953125 -67.40625 C 58.816406 -67.257812 59.566406 -67.507812 60.203125 -68.15625 C 60.847656 -68.800781 61.171875 -69.550781 61.171875 -70.40625 C 61.316406 -72.269531 61.351562 -74.628906 61.28125 -77.484375 C 61.207031 -80.347656 60.957031 -82.925781 60.53125 -85.21875 C 59.957031 -89.800781 58.773438 -93.519531 56.984375 -96.375 C 55.203125 -99.238281 51.59375 -100.742188 46.15625 -100.890625 C 42 -101.035156 38.773438 -100.425781 36.484375 -99.0625 C 34.203125 -97.707031 32.554688 -96.238281 31.546875 -94.65625 C 30.546875 -93.082031 29.832031 -92.007812 29.40625 -91.4375 C 29.257812 -91.15625 29.113281 -90.117188 28.96875 -88.328125 C 28.832031 -86.535156 28.765625 -85.359375 28.765625 -84.796875 C 28.765625 -82.210938 27.546875 -80.921875 25.109375 -80.921875 C 24.972656 -80.921875 24.113281 -80.921875 22.53125 -80.921875 C 20.957031 -80.921875 19.347656 -80.921875 17.703125 -80.921875 C 16.054688 -80.921875 15.09375 -80.921875 14.8125 -80.921875 C 13.664062 -80.921875 12.660156 -81.242188 11.796875 -81.890625 C 10.941406 -82.535156 10.585938 -83.644531 10.734375 -85.21875 C 10.734375 -85.363281 10.695312 -86.722656 10.625 -89.296875 C 10.550781 -91.867188 10.515625 -93.800781 10.515625 -95.09375 C 10.660156 -95.375 10.769531 -95.726562 10.84375 -96.15625 C 10.914062 -96.59375 11.019531 -96.953125 11.15625 -97.234375 C 11.875 -98.671875 13.410156 -100.925781 15.765625 -104 C 18.128906 -107.070312 21.742188 -109.929688 26.609375 -112.578125 C 31.484375 -115.234375 37.851562 -116.628906 45.71875 -116.765625 C 52.300781 -116.910156 57.523438 -116.085938 61.390625 -114.296875 C 65.253906 -112.515625 68.363281 -110.15625 70.71875 -107.21875 C 73.082031 -104.289062 75.269531 -101.035156 77.28125 -97.453125 C 78.851562 -94.734375 79.957031 -91.617188 80.59375 -88.109375 C 81.238281 -84.609375 81.632812 -80.925781 81.78125 -77.0625 C 81.925781 -75.195312 82.035156 -72.117188 82.109375 -67.828125 C 82.179688 -63.535156 82.25 -58.773438 82.3125 -53.546875 C 82.382812 -48.328125 82.457031 -43.25 82.53125 -38.3125 C 82.601562 -33.375 82.675781 -29.257812 82.75 -25.96875 C 82.820312 -22.675781 82.859375 -20.960938 82.859375 -20.828125 C 82.859375 -17.535156 83.785156 -15.890625 85.640625 -15.890625 Z M 38.421875 -18.03125 C 41.285156 -17.75 44.46875 -18.210938 47.96875 -19.421875 C 51.476562 -20.640625 54.59375 -22.394531 57.3125 -24.6875 C 60.03125 -26.976562 61.460938 -29.410156 61.609375 -31.984375 C 61.753906 -33.847656 61.789062 -36.457031 61.71875 -39.8125 C 61.644531 -43.175781 61.535156 -46.078125 61.390625 -48.515625 C 61.390625 -50.234375 60.457031 -51.234375 58.59375 -51.515625 C 55.738281 -51.660156 52.445312 -51.695312 48.71875 -51.625 C 45 -51.550781 41.78125 -51.15625 39.0625 -50.4375 C 35.195312 -49.4375 32.515625 -47.828125 31.015625 -45.609375 C 29.515625 -43.390625 28.65625 -40.992188 28.4375 -38.421875 C 28.226562 -35.847656 28.125 -33.34375 28.125 -30.90625 C 28.125 -23.46875 31.554688 -19.175781 38.421875 -18.03125 Z M 38.421875 -18.03125 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#ff914d",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(227.750612, 205.367311)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 73.203125 -114.203125 C 72.910156 -111.910156 72.476562 -109.046875 71.90625 -105.609375 C 71.332031 -102.171875 70.691406 -99.023438 69.984375 -96.171875 C 69.835938 -95.304688 69.332031 -94.695312 68.46875 -94.34375 C 67.613281 -93.988281 66.828125 -94.023438 66.109375 -94.453125 C 62.390625 -96.742188 58.421875 -97.851562 54.203125 -97.78125 C 49.984375 -97.707031 46.007812 -96.453125 42.28125 -94.015625 C 41.570312 -93.304688 41.21875 -92.519531 41.21875 -91.65625 L 41.21875 -19.3125 C 41.21875 -18.457031 41.535156 -17.671875 42.171875 -16.953125 C 42.816406 -16.242188 43.644531 -15.890625 44.65625 -15.890625 L 47.875 -15.671875 C 50.15625 -15.671875 51.296875 -14.671875 51.296875 -12.671875 L 51.296875 -3.4375 C 51.441406 -2.4375 51.15625 -1.578125 50.4375 -0.859375 C 49.726562 -0.140625 48.875 0.21875 47.875 0.21875 L 14.171875 0.21875 C 13.171875 0.21875 12.347656 -0.140625 11.703125 -0.859375 C 11.054688 -1.578125 10.734375 -2.4375 10.734375 -3.4375 L 10.734375 -12.453125 C 10.734375 -14.597656 11.878906 -15.671875 14.171875 -15.671875 L 16.3125 -15.671875 C 18.601562 -15.671875 19.75 -16.882812 19.75 -19.3125 L 19.3125 -95.3125 C 19.3125 -96.738281 18.8125 -97.953125 17.8125 -98.953125 C 16.8125 -99.953125 15.597656 -100.453125 14.171875 -100.453125 L 13.515625 -100.453125 C 12.085938 -100.597656 10.910156 -101.171875 9.984375 -102.171875 C 9.054688 -103.171875 8.59375 -104.390625 8.59375 -105.828125 L 8.59375 -112.265625 C 8.59375 -113.835938 9.09375 -115.125 10.09375 -116.125 C 11.09375 -117.125 12.304688 -117.625 13.734375 -117.625 L 36.484375 -117.625 C 39.066406 -117.625 40.5 -116.265625 40.78125 -113.546875 L 40.78125 -112.90625 C 40.78125 -111.90625 41.210938 -111.691406 42.078125 -112.265625 C 44.929688 -115.128906 47.96875 -117.097656 51.1875 -118.171875 C 54.414062 -119.242188 58.03125 -119.78125 62.03125 -119.78125 C 63.175781 -119.78125 64.609375 -119.53125 66.328125 -119.03125 C 68.046875 -118.53125 69.550781 -118.0625 70.84375 -117.625 C 72.695312 -116.914062 73.484375 -115.773438 73.203125 -114.203125 Z M 73.203125 -114.203125 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#ff914d",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(311.894869, 205.367311)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 91.4375 -88.65625 C 91.4375 -86.644531 91.507812 -83.457031 91.65625 -79.09375 C 91.800781 -74.726562 91.910156 -69.753906 91.984375 -64.171875 C 92.054688 -58.597656 92.160156 -52.910156 92.296875 -47.109375 C 92.441406 -41.316406 92.550781 -36.023438 92.625 -31.234375 C 92.695312 -26.441406 92.804688 -22.613281 92.953125 -19.75 C 92.953125 -17.175781 94.3125 -15.890625 97.03125 -15.890625 L 99.59375 -15.671875 C 100.738281 -15.671875 101.671875 -15.3125 102.390625 -14.59375 C 103.109375 -13.875 103.46875 -12.945312 103.46875 -11.8125 L 103.671875 -4.078125 C 103.671875 -2.929688 103.273438 -1.960938 102.484375 -1.171875 C 101.703125 -0.390625 100.738281 0 99.59375 0 L 65.25 0 C 64.25 0 63.316406 -0.390625 62.453125 -1.171875 C 61.597656 -1.960938 61.171875 -2.929688 61.171875 -4.078125 L 61.171875 -11.8125 C 61.171875 -12.945312 61.5625 -13.910156 62.34375 -14.703125 C 63.132812 -15.492188 64.101562 -15.890625 65.25 -15.890625 L 66.546875 -15.890625 C 67.691406 -15.890625 68.65625 -16.28125 69.4375 -17.0625 C 70.226562 -17.851562 70.625 -18.820312 70.625 -19.96875 L 69.328125 -89.9375 C 69.191406 -94.800781 67.441406 -98.234375 64.078125 -100.234375 C 60.710938 -102.242188 56.8125 -103.035156 52.375 -102.609375 C 47.9375 -102.179688 43.859375 -100.75 40.140625 -98.3125 C 38.992188 -97.59375 38.421875 -96.519531 38.421875 -95.09375 L 38.421875 -19.75 C 38.421875 -17.175781 39.78125 -15.890625 42.5 -15.890625 L 45.296875 -15.671875 C 48.015625 -15.671875 49.375 -14.3125 49.375 -11.59375 L 49.375 -4.078125 C 49.375 -2.929688 48.976562 -1.960938 48.1875 -1.171875 C 47.40625 -0.390625 46.441406 0 45.296875 0 L 12.015625 0 C 11.015625 0 10.082031 -0.390625 9.21875 -1.171875 C 8.363281 -1.960938 7.9375 -2.929688 7.9375 -4.078125 L 8.15625 -11.8125 C 8.15625 -12.945312 8.546875 -13.875 9.328125 -14.59375 C 10.117188 -15.3125 11.015625 -15.671875 12.015625 -15.671875 L 13.09375 -15.671875 C 14.238281 -15.671875 15.203125 -16.097656 15.984375 -16.953125 C 16.773438 -17.816406 17.171875 -18.75 17.171875 -19.75 L 16.53125 -97.234375 C 16.53125 -98.523438 16.097656 -99.597656 15.234375 -100.453125 C 14.378906 -101.316406 13.378906 -101.820312 12.234375 -101.96875 L 10.953125 -101.96875 C 9.804688 -102.101562 8.765625 -102.597656 7.828125 -103.453125 C 6.898438 -104.316406 6.4375 -105.394531 6.4375 -106.6875 L 6.4375 -112.90625 C 6.4375 -114.34375 6.898438 -115.488281 7.828125 -116.34375 C 8.765625 -117.195312 9.875 -117.625 11.15625 -117.625 L 32.625 -117.625 C 34.0625 -117.625 35.28125 -117.125 36.28125 -116.125 C 37.28125 -115.125 37.851562 -113.910156 38 -112.484375 L 38 -111.1875 C 38 -110.613281 38.285156 -110.472656 38.859375 -110.765625 C 41.710938 -113.765625 44.570312 -115.800781 47.4375 -116.875 C 50.300781 -117.945312 53.738281 -118.484375 57.75 -118.484375 C 64.894531 -118.484375 70.6875 -117.445312 75.125 -115.375 C 79.5625 -113.300781 82.925781 -110.691406 85.21875 -107.546875 C 87.507812 -104.398438 89.082031 -101.144531 89.9375 -97.78125 C 90.800781 -94.414062 91.300781 -91.375 91.4375 -88.65625 Z M 91.4375 -88.65625 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#ff914d",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(432.744769, 205.367311)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.296875 -4.296875 L 5.15625 -14.171875 C 5.15625 -14.878906 5.472656 -15.519531 6.109375 -16.09375 C 6.753906 -16.664062 7.4375 -16.953125 8.15625 -16.953125 L 11.59375 -16.953125 C 12.445312 -16.953125 13.195312 -17.273438 13.84375 -17.921875 C 14.488281 -18.566406 14.8125 -19.316406 14.8125 -20.171875 L 14.8125 -99.171875 C 14.8125 -101.171875 13.8125 -102.171875 11.8125 -102.171875 L 8.796875 -102.390625 C 6.796875 -102.390625 5.796875 -103.390625 5.796875 -105.390625 L 5.359375 -115.265625 C 5.359375 -117.410156 6.363281 -118.484375 8.375 -118.484375 L 33.0625 -118.484375 C 35.207031 -118.484375 36.28125 -117.484375 36.28125 -115.484375 L 38 -20.171875 C 38.28125 -18.171875 39.351562 -17.171875 41.21875 -17.171875 L 43.796875 -16.953125 C 44.503906 -16.953125 45.179688 -16.664062 45.828125 -16.09375 C 46.472656 -15.519531 46.796875 -14.804688 46.796875 -13.953125 L 47.015625 -4.078125 C 47.015625 -1.929688 45.941406 -0.859375 43.796875 -0.859375 L 10.953125 -0.859375 C 9.941406 -0.859375 8.578125 -1.179688 6.859375 -1.828125 C 5.148438 -2.472656 4.296875 -3.296875 4.296875 -4.296875 Z M 36.0625 -141.25 C 35.914062 -138.09375 34.234375 -136.015625 31.015625 -135.015625 C 27.796875 -134.015625 24.253906 -133.585938 20.390625 -133.734375 C 16.378906 -134.015625 13.585938 -134.941406 12.015625 -136.515625 C 10.441406 -138.085938 9.515625 -140.664062 9.234375 -144.25 C 9.085938 -149.113281 10.191406 -152.507812 12.546875 -154.4375 C 14.910156 -156.375 18.742188 -157.269531 24.046875 -157.125 C 27.765625 -156.976562 30.484375 -156.257812 32.203125 -154.96875 C 33.921875 -153.6875 35.03125 -152.148438 35.53125 -150.359375 C 36.03125 -148.578125 36.242188 -146.828125 36.171875 -145.109375 C 36.097656 -143.390625 36.0625 -142.101562 36.0625 -141.25 Z M 36.0625 -141.25 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#ff914d",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.779801, 205.367311)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 38.203125 -15.890625 C 39.773438 -15.890625 41.0625 -15.382812 42.0625 -14.375 C 43.070312 -13.375 43.578125 -12.085938 43.578125 -10.515625 L 43.578125 -6.015625 C 43.578125 -4.441406 43.003906 -3.046875 41.859375 -1.828125 C 40.710938 -0.609375 39.28125 0 37.5625 0 L 10.515625 -0.21875 C 8.796875 -0.21875 7.328125 -0.859375 6.109375 -2.140625 C 4.898438 -3.429688 4.363281 -4.863281 4.5 -6.4375 L 4.71875 -11.15625 C 4.71875 -12.445312 5.179688 -13.59375 6.109375 -14.59375 C 7.046875 -15.59375 8.226562 -16.164062 9.65625 -16.3125 L 11.375 -16.53125 C 13.375 -16.53125 14.945312 -17.457031 16.09375 -19.3125 L 42.078125 -57.09375 C 43.929688 -60.25 43.859375 -63.1875 41.859375 -65.90625 L 18.671875 -99.390625 C 17.671875 -101.109375 16.097656 -101.96875 13.953125 -101.96875 L 11.375 -102.171875 C 9.945312 -102.171875 8.695312 -102.707031 7.625 -103.78125 C 6.550781 -104.851562 6.015625 -106.109375 6.015625 -107.546875 L 6.21875 -111.625 C 6.21875 -113.195312 6.789062 -114.554688 7.9375 -115.703125 C 9.082031 -116.847656 10.515625 -117.421875 12.234375 -117.421875 L 40.5625 -117.421875 C 42.28125 -117.421875 43.710938 -116.8125 44.859375 -115.59375 C 46.003906 -114.375 46.578125 -112.90625 46.578125 -111.1875 L 46.15625 -107.75 C 46.15625 -106.320312 45.6875 -105.144531 44.75 -104.21875 C 43.820312 -103.289062 42.644531 -102.753906 41.21875 -102.609375 C 40.644531 -102.460938 40.25 -102.140625 40.03125 -101.640625 C 39.820312 -101.140625 39.929688 -100.675781 40.359375 -100.25 L 53.234375 -80.0625 C 53.660156 -79.488281 54.234375 -79.164062 54.953125 -79.09375 C 55.671875 -79.03125 56.316406 -79.285156 56.890625 -79.859375 L 69.765625 -99.390625 C 70.335938 -99.960938 70.441406 -100.566406 70.078125 -101.203125 C 69.722656 -101.847656 69.1875 -102.242188 68.46875 -102.390625 C 67.1875 -102.390625 66.039062 -102.890625 65.03125 -103.890625 C 64.03125 -104.890625 63.53125 -106.035156 63.53125 -107.328125 L 63.109375 -111.84375 C 63.109375 -113.550781 63.679688 -115.015625 64.828125 -116.234375 C 65.972656 -117.453125 67.40625 -118.0625 69.125 -118.0625 L 97.03125 -117.84375 C 98.601562 -117.84375 99.960938 -117.304688 101.109375 -116.234375 C 102.253906 -115.160156 102.894531 -113.835938 103.03125 -112.265625 L 103.25 -107.75 C 103.25 -106.320312 102.75 -105.035156 101.75 -103.890625 C 100.75 -102.742188 99.53125 -102.171875 98.09375 -102.171875 L 96.375 -101.96875 C 94.375 -101.96875 92.515625 -101.109375 90.796875 -99.390625 L 67.1875 -64.609375 C 65.039062 -62.179688 64.898438 -59.675781 66.765625 -57.09375 L 92.09375 -19.3125 C 93.800781 -17.164062 95.875 -16.09375 98.3125 -16.09375 L 100.25 -15.890625 C 101.820312 -15.890625 103.109375 -15.382812 104.109375 -14.375 C 105.109375 -13.375 105.609375 -12.085938 105.609375 -10.515625 L 105.609375 -6.015625 C 105.460938 -4.296875 104.816406 -2.863281 103.671875 -1.71875 C 102.535156 -0.570312 101.175781 0 99.59375 0 L 69.125 0 C 67.550781 0 66.15625 -0.535156 64.9375 -1.609375 C 63.71875 -2.679688 63.109375 -4.003906 63.109375 -5.578125 L 62.890625 -10.296875 C 62.742188 -11.878906 63.207031 -13.207031 64.28125 -14.28125 C 65.363281 -15.351562 66.691406 -15.890625 68.265625 -15.890625 C 68.972656 -16.023438 69.539062 -16.453125 69.96875 -17.171875 C 70.40625 -17.890625 70.410156 -18.601562 69.984375 -19.3125 L 57.09375 -40.78125 C 56.664062 -41.5 55.878906 -41.925781 54.734375 -42.0625 C 53.585938 -42.207031 52.726562 -41.925781 52.15625 -41.21875 L 36.921875 -18.25 C 36.628906 -17.820312 36.625 -17.320312 36.90625 -16.75 C 37.195312 -16.175781 37.628906 -15.890625 38.203125 -15.890625 Z M 38.203125 -15.890625 "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d311b0f7f4cfca403a4d2c5719671827.svg";
export { ForwardRef as ReactComponent };